/**
 * Irish (Gaeilge) translations
 * Coláiste Lurgan Management System
 */

const gaTranslations = {
// Auth & Login
"app.title": "Coláiste Lurgan",
"app.subtitle": "Córas Bainistíochta na nDaltaí",
"login.title": "Coláiste Lurgan",
"login.subtitle": "Córas Bainistíochta",
"login.username": "Ainm Úsáideora",
"login.password": "Pasfhocal",
"login.submit": "Logáil Isteach",
"login.loggingIn": "Ag Logáil Isteach...",
"login.trouble": "An bhfuil fadhbanna agat?",
"login.contact": "Déan teagmháil leis an riarachán",
"login.show": "Taispeáin",
"login.hide": "Folaigh",
"login.errors.required": "Tá an réimse seo riachtanach",
"login.errors.username": "Ainm úsáideora riachtanach",
"login.errors.password": "Pasfhocal riachtanach",
"login.errors.network": "Earráid líonra. Seiceáil do nasc le do thoil.",
"login.errors.unauthorized": "Ainm úsáideora nó pasfhocal mícheart",
"login.errors.generic": "Tharla earráid gan choinne. Bain triail eile as.",
"login.forgotPassword": "Pasfhocal dearmadta?",
"login.rememberMe": "Cuimhnigh mé ar feadh 7 lá",

// Forgot Password
"forgotPassword.title": "Athshocraigh Pasfhocal",
"forgotPassword.description": "Cuir isteach do sheoladh ríomhphoist agus seolfaimid nasc chugat chun do phasfhocal a athshocrú.",
"forgotPassword.emailLabel": "Seoladh Ríomhphoist",
"forgotPassword.submit": "Seol Nasc Athshocraithe",
"forgotPassword.successTitle": "Seiceáil Do Ríomhphost",
"forgotPassword.successDesc": "Má tá cuntas ann don seoladh sin, tá nasc athshocraithe pasfhocail seolta. Seiceáil do bhosca isteach.",
"forgotPassword.backToLogin": "Ar ais chuig logáil isteach",

// Reset Password
"resetPassword.title": "Socraigh Pasfhocal Nua",
"resetPassword.description": "Cuir isteach do phasfhocal nua thíos.",
"resetPassword.newPassword": "Pasfhocal Nua",
"resetPassword.confirmPassword": "Deimhnigh Pasfhocal",
"resetPassword.submit": "Athshocraigh Pasfhocal",
"resetPassword.successTitle": "Pasfhocal Athshocraithe",
"resetPassword.successDesc": "Athsocraíodh do phasfhocal go rathúil. Ag atreorú chuig logáil isteach...",
"resetPassword.invalidToken": "Nasc Athshocraithe Mícheart",
"resetPassword.invalidTokenDesc": "Tá an nasc athshocraithe pasfhocail seo mícheart nó in éag. Iarr ceann nua le do thoil.",

// MFA
"mfa.title": "Deimhnigh d'Aitheantas",
"mfa.instruction": "Cuir isteach an cód 6-digit a seoladh chuig do ríomhphost",
"mfa.codeLabel": "Cód Logáil Isteach",
"mfa.verify": "Deimhnigh",
"mfa.verifying": "Ag deimhniú...",
"mfa.resend": "Athsheol cód",
"mfa.resending": "Ag athsheoladh...",
"mfa.errors.invalidCode": "Cuir isteach cód 6-digit le do thoil",
"mfa.errors.failed": "Cód mícheart nó in éag. Bain triail eile as.",
"mfa.errors.resendFailed": "Theip ar athsheoladh an chóid. Bain triail eile as.",

// Profile
"profile.title": "Mo Phróifíl",
"profile.description": "Bainistigh socruithe agus roghanna do chuntais",
"profile.personal.title": "Faisnéis Phearsanta",
"profile.personal.description": "Nuashonraigh d'ainm agus do shonraí teagmhála",
"profile.username": "Ainm Úsáideora",
"profile.usernameNote": "Ní féidir d'ainm úsáideora a athrú",
"profile.firstName": "Céadainm",
"profile.lastName": "Sloinne",
"profile.email": "Seoladh Ríomhphoist",
"profile.verified": "Deimhnithe",
"profile.unverified": "Gan Deimhniú",
"profile.editProfile": "Cuir Próifíl in Eagar",
"profile.phoneNumber": "Uimhir Ghutháin",
"profile.phoneRequired": "Riachtanach do chuntais tuismitheoirí",
"profile.parentSyncNote": "Má dhéanann tú do ainm, uimhir ghutháin nó ríomhphost a nuashonrú, nuashonrófar taifid do linbh freisin.",
"profile.security.title": "Slándáil",
"profile.security.description": "Bainistigh do phasfhocal agus slándáil do chuntais",
"profile.password": "Pasfhocal",
"profile.passwordNote": "Coinnigh do chuntas slán le pasfhocal láidir",
"profile.changePassword": "Athraigh Pasfhocal",
"profile.passwordChangeDescription": "Cuir isteach do phasfhocal reatha agus roghnaigh ceann nua",
"profile.currentPassword": "Pasfhocal Reatha",
"profile.newPassword": "Pasfhocal Nua",
"profile.confirmPassword": "Deimhnigh Pasfhocal",
"profile.updatePassword": "Nuashonraigh Pasfhocal",
"profile.twoFactor": "Fíordheimhniú Dhá Fhachtóir",
"profile.twoFactorNote": "Seoltar cóid logála isteach chuig do ríomhphost ag gach síniú isteach",
"profile.enable": "Cumasaithe",
"profile.language": "Teanga",
"profile.languageNote": "Roghnaigh an teanga comhéadain is fearr leat",
"profile.languageSwitchHint": "Úsáid cnaipe na teanga sa bharra nascleanúna thuas chun an teanga a athrú.",
"profile.appearance": "Cuma",
"profile.appearanceNote": "Roghnaigh do scéim datha is fearr leat",
"profile.theme.light": "Solas",
"profile.theme.dark": "Dorcha",
"profile.theme.system": "Córas",
"profile.changeEmail": "Athraigh Seoladh Ríomhphoist",
"profile.newEmail": "Seoladh Ríomhphoist Nua",
"profile.emailChangeWarning": "Seolfar ríomhphost deimhniúcháin chuig do sheoladh nua. Fanann do sheoladh reatha gníomhach go dtí go ndeimhnítear é.",
"profile.emailChangeSent": "Ríomhphost deimhniúcháin seolta chuig {{email}}. Seiceáil do bhosca isteach.",
"profile.emailChangeFailed": "Theip ar sheoladh an ríomhphoist deimhniúcháin. Bain triail eile as.",
"profile.toast.profileUpdated": "Próifíl nuashonraithe",
"profile.toast.profileUpdatedDesc": "Sábháladh do phróifíl go rathúil",
"profile.toast.updateFailed": "Theip ar an nuashonrú",
"profile.toast.updateFailedDesc": "Níorbh fhéidir athruithe do phróifíl a shábháil",
"profile.toast.passwordMismatch": "Níl na pasfhocail mar an gcéanna",
"profile.toast.passwordMismatchDesc": "Déan cinnte go bhfuil an dá réimse pasfhocail mar an gcéanna",
"profile.toast.passwordTooShort": "Pasfhocal rófhada",
"profile.toast.passwordTooShortDesc": "Caithfidh an pasfhocal a bheith ar a laghad 8 gcarachtar ar fhad",
"profile.toast.passwordUpdated": "Pasfhocal nuashonraithe",
"profile.toast.passwordUpdatedDesc": "Athraíodh do phasfhocal go rathúil",
"profile.toast.passwordChangeFailed": "Theip ar athrú pasfhocail",
"profile.toast.passwordChangeFailedDesc": "Níorbh fhéidir do phasfhocal a athrú. Bain triail eile as.",
"profile.toast.themeUpdated": "Téama nuashonraithe",
"profile.toast.themeUpdatedDesc": "Athraíodh go mód {{theme}}",
"profile.preferences": "Roghanna",
"profile.preferencesNote": "Socruithe teanga agus taispeána",
"profile.unsavedChanges": "Athruithe gan sábháil",
"profile.changeEmailShort": "Athraigh",
"profile.saveAndSend": "Sábháil & Seol",
"profile.twoFactorActive": "Ríomhphost Gníomhach",
"profile.twoFactorAppComingSoon": "2FA bunaithe ar aip ag teacht go luath",
"profile.passwordStrength.weak": "Lag",
"profile.passwordStrength.fair": "Measartha",
"profile.passwordStrength.good": "Maith",
"profile.passwordStrength.strong": "Láidir",
"common.send": "Seol",

// My Student Detail (parent view)
"myStudent.back": "Deais Teaghlaigh",
"myStudent.personalDetails": "Sonraí Pearsanta",
"myStudent.placement": "Lonnú",
"myStudent.attendanceHistory": "Stair Freastail",
"myStudent.saveSuccess": "nuashonraithe go rathúil.",
"myStudent.saveError": "Theip ar shábháil athruithe. Bain triail eile as.",
"myStudent.missingEmailBanner": "Tá seoladh ríomhphoist do linbh ar iarraidh. Beidh sé ag teastáil uathu chun teacht ar Oide, an t-ardán foghlama ar líne.",
"myStudent.addEmail": "Cuir Ríomhphost Leis",
"myStudent.missingPhoneBanner": "Tá uimhir ghutháin do thuismitheora/chaomhnóra ar iarraidh. Cuir leis í le do thoil ionas gur féidir leis an gcoláiste teagmháil a dhéanamh leat más gá.",
"myStudent.addPhone": "Cuir Uimhir Ghutháin Leis",
"myStudent.missingAddressBanner": "Tá seoladh agus sonraí taistil do linbh ar iarraidh. Cuir leo iad sula dtosaíonn an cúrsa, le do thoil.",
"myStudent.addDetails": "Cuir Sonraí Leis",
"myStudent.pastStudentBanner": "Is iarchlárú é seo. Tá an taifead inléite amháin agus á choinneáil mar thagairt duit.",

// Family Dashboard
"familyDashboard.title": "Deais Teaghlaigh",
"familyDashboard.description": "Féach ar shonraí agus eolas íocaíochta do pháistí.",
"familyDashboard.myChildren": "Mo Pháistí",
"familyDashboard.noChildren": "Níor aimsíodh daltaí nasctha le do chuntas. Déan teagmháil leis an gcoláiste le do thoil.",
"familyDashboard.viewAndEdit": "Féach & Cuir in Eagar",
"familyDashboard.viewDetails": "Féach ar Shonraí",
"familyDashboard.cancelled": "Cealaithe",
"familyDashboard.paid": "Íoctha",
"familyDashboard.balance": "Iarmhéid dlite",
"familyDashboard.pastStudent": "Iar-dhalta",
"familyDashboard.pastStudents": "Iar-dhaltaí",

// Email Verification
"verifyEmail.title": "Socraigh Do Phasfhocal",
"verifyEmail.subtitle": "Cruthaigh pasfhocal slán do do chuntas le do thoil",
"verifyEmail.password": "Pasfhocal",
"verifyEmail.confirmPassword": "Deimhnigh Pasfhocal",
"verifyEmail.passwordPlaceholder": "Cuir isteach do phasfhocal",
"verifyEmail.confirmPasswordPlaceholder": "Deimhnigh do phasfhocal",
"verifyEmail.passwordRequirements": "Ar a laghad 12 gcarachtar le ceannlitir, litir bheag, uimhir agus carachtar speisialta",
"verifyEmail.req.length": "Ar a laghad 12 gcarachtar",
"verifyEmail.req.upper": "Ceannlitir amháin (A–Z)",
"verifyEmail.req.lower": "Litir bheag amháin (a–z)",
"verifyEmail.req.number": "Uimhir amháin (0–9)",
"verifyEmail.req.special": "Carachtar speisialta amháin (!@#$%^&*)",
"verifyEmail.submit": "Socraigh Pasfhocal agus Fíoraigh",
"verifyEmail.submitting": "Ag Socrú Pasfhocail...",
"verifyEmail.show": "Taispeáin",
"verifyEmail.hide": "Folaigh",
"verifyEmail.backToLogin": "Ar Ais go Logáil Isteach",
"verifyEmail.goToLogin": "Téigh go Logáil Isteach",
"verifyEmail.invalidLink": "Nasc Fíoraithe Neamhbhailí",
"verifyEmail.success.title": "Ríomhphost Fíoraithe",
"verifyEmail.success.description": "Fíoraíodh do ríomhphost go rathúil. Is féidir leat logáil isteach anois.",
"verifyEmail.errors.noToken": "Ní bhfuarthas comhartha fíoraithe san URL",
"verifyEmail.errors.tokenInvalid": "Níl an nasc seo bailí a thuilleadh. Déan teagmháil leis an gcoláiste chun ceann nua a fháil.",
"verifyEmail.errors.passwordMin": "Caithfidh pasfhocal a bheith 12 gcarachtar ar a laghad",
"verifyEmail.errors.passwordSpecial": "Caithfidh carachtar speisialta amháin ar a laghad a bheith sa phasfhocal (!@#$%^&*)",
"verifyEmail.errors.passwordUppercase": "Caithfidh ceannlitir amháin ar a laghad a bheith sa phasfhocal",
"verifyEmail.errors.passwordLowercase": "Caithfidh litir bheag amháin ar a laghad a bheith sa phasfhocal",
"verifyEmail.errors.passwordNumber": "Caithfidh uimhir amháin ar a laghad a bheith sa phasfhocal",
"verifyEmail.errors.confirmRequired": "Deimhnigh do phasfhocal le do thoil",
"verifyEmail.errors.passwordMatch": "Ní hionann na pasfhocail",
"verifyEmail.errors.default": "Theip ar fhíorú. Bain triail eile as.",

// Navigation & Layout  
"nav.dashboard": "Painéal",
"nav.students": "Daltaí",
"nav.courses": "Cúrsaí", 
"nav.houses": "Tithe",
"nav.classes": "Ranganna",
"nav.payments": "Íocaíochtaí",
"nav.communications": "Cumarsáid",
"nav.travel": "Taisteal",
"nav.settings": "Socruithe",
"nav.auditLog": "Loga Iniúchta",
"nav.profile": "Próifíl",
"nav.familyDashboard": "Deais Teaghlaigh",
"nav.help": "Cabhair",
"nav.logout": "Logáil Amach",
"nav.loggingOut": "Ag Logáil Amach...",

// User Types
"userType.ADMIN": "Riarthóir",
"userType.TEACHER": "Múinteoir",
"userType.OFFICE": "Foireann Oifige",
"userType.HOUSE_OWNER": "Úinéir Tí",
"userType.INTERVIEWER": "Agallóir",
"userType.PARENT": "Tuismitheoir",
"userType.label": "Cineál Úsáideora",

// Dashboard
"dashboard.courseOverview": "Forbhreathnú ar Chúrsaí",
"dashboard.welcome.ADMIN": "Fáilte ar ais, a Riarthóir!",
"dashboard.welcome.TEACHER": "Fáilte ar ais, a Mhúinteoir!",
"dashboard.welcome.OFFICE": "Fáilte ar ais, Foireann Oifige!",
"dashboard.welcome.HOUSE_OWNER": "Fáilte ar ais, a Úinéir Tí!",
"dashboard.welcome.INTERVIEWER": "Fáilte ar ais, a Agallóir!",
"dashboard.welcome.PARENT": "Fáilte ar ais!",
"dashboard.subtitle": "Anailísíocht do chúrsaí atá le teacht",

// Dashboard Cards
"dashboard.students": "Daltaí",
"dashboard.activeCourses": "Cúrsaí Gníomhacha",
"dashboard.houses": "Tithe",
"dashboard.classes": "Ranganna",
"dashboard.pendingPayments": "Íocaíochtaí ar Feitheamh",
"dashboard.systemPerformance": "Feidhmíocht an Chórais",
"dashboard.quickActions": "Gníomhartha Tapa",
"dashboard.systemStatus": "Stádas an Chórais",
"dashboard.yourInformation": "D'Eolas",

// Dashboard Stats
"dashboard.newThisWeek": "nua le seachtain",
"dashboard.currentSeason": "don séasúr reatha",
"dashboard.available": "ar fáil",
"dashboard.organized": "eagraithe",
"dashboard.awaitingProcessing": "ag feitheamh le próiseáil",
"dashboard.uptime": "am suas",

// Dashboard Analytics
"dashboard.clearFilter": "Glan Scagaire",
"dashboard.totalStudents": "Daltaí Iomlána",
"dashboard.totalWithCinnire": "Iomlán le Cinnirí",
"dashboard.withCinnire": "Le Cinnirí",
"dashboard.cancelled": "Cealaithe",
"dashboard.registered": "Cláraithe do chúrsaí atá le teacht",
"dashboard.upcoming": "Seisiúin atá le teacht",
"dashboard.genderSplit": "Roinnt Inscne",
"dashboard.countyReach": "Raon Contaetha",
"dashboard.countiesRepresented": "Contaetha ionadaithe",
"dashboard.courseEnrollment": "Rollú de réir Cúrsa",
"dashboard.genderByCourse": "Dáileadh Inscne de réir Cúrsa",
"dashboard.schoolYears": "Miondealú Bliain Scoile",
"dashboard.total": "Iomlán",
"dashboard.topCounties": "Barr Contaetha",
"dashboard.travelLocations": "Suímh Taistil",
"dashboard.studentsRequireTravel": "daltaí ag teastáil taisteal",
"dashboard.courseDetails": "Sonraí Cúrsa",
"dashboard.courseName": "Ainm Cúrsa",
"dashboard.dates": "Dátaí",
"dashboard.capacity": "Acmhainn",
"dashboard.male": "Fireann",
"dashboard.female": "Baineann",
"dashboard.cinnire": "Cinnirí (Ceannairí)",
"dashboard.cinnireNote": "(San iomlán thuas)",
"dashboard.travel": "Taisteal",
"dashboard.showing": "Ag taispeáint barr 10 de",
"dashboard.counties": "contaetha",
"dashboard.clickToFilter": "Cliceáil barra chun sonraí a scagadh",
"dashboard.allCourses": "Gach Cúrsa",
"dashboard.viewDetails": "Féach ar shonraí",
"dashboard.noCourses": "Níl cúrsaí ar na bacáin",
"dashboard.noCoursesAllTime": "Níl cúrsaí le fáil",
"courseFilter.upcoming": "Le Teacht",
"courseFilter.allTime": "Gach Am",
"courseFilter.ended": "Críochnaithe",
"dashboard.interviews": "Agallaimh",
"dashboard.placement": "Lóistín",
"dashboard.unassigned": "Gan Sannadh",
"dashboard.payments": "Íocaíochtaí",
"dashboard.fullyPaid": "Íoctha go hIomlán",
"dashboard.outstanding": "Gan Íoc",
"dashboard.noPayment": "Gan Íocaíocht",

// Interviewer Dashboard
"interviewDashboard.title": "Forbhreathnú ar Agallaimh",
"interviewDashboard.subtitle": "Do dhul chun cinn agallaimh trasna cúrsaí",
"interviewDashboard.totalPending": "Iomlán ar Feitheamh",
"interviewDashboard.pendingCourses": "Cúrsaí ar Feitheamh",
"interviewDashboard.myAvgScore": "Mo Mheánscór",
"interviewDashboard.interviews": "Agallaimh",
"interviewDashboard.pending": "Ar Feitheamh",
"interviewDashboard.scored": "Scóráilte",
"interviewDashboard.notRequired": "Níl ag Teastáil",
"interviewDashboard.myScores": "Mo Scóir",
"interviewDashboard.completed": "Críochnaithe",
"interviewDashboard.avgScore": "Meánscór",
"interviewDashboard.noCourses": "Níl aon chúrsaí le teacht",
"interviewDashboard.noCoursesDescription": "Níl aon chúrsaí gníomhacha le daltaí le hagallamh.",

// Quick Actions
"dashboard.addNewStudent": "Cuir dalta nua leis",
"dashboard.manageCourses": "Bainistigh cúrsaí",
"dashboard.assignHouses": "Sannadh tithe",

// System Status
"dashboard.database": "Bunachar Sonraí",
"dashboard.apiServices": "Seirbhísí API",
"dashboard.emailService": "Seirbhís Ríomhphoist", 
"dashboard.backups": "Cúltaca",
"dashboard.status.active": "Gníomhach",
"dashboard.status.slow": "Mall",
"dashboard.status.successful": "Rathúil",

// User Information
"dashboard.name": "Ainm",
"dashboard.email": "Ríomhphost",
"dashboard.loggedIn": "Logáilte Isteach",

// Access Control
"access.denied": "Rochtain Diúltaithe",
"access.noPermission": "Níl cead agat an leathanach seo a fheiceáil.",
"access.goBack": "Ar ais",
"access.permissionsRequired": "Ceadanna Riachtanacha",
"access.noPermissionAction": "Ní bhfuair tú na ceadanna riachtanacha don gníomhaíocht seo.",

// Loading States
"loading.text": "Ag luchtú...",
"common.back": "Ar ais",
"common.loading": "Ag luchtú...",
"common.errorLoading": "Tharla earráid agus an leathanach á luchtú. Déan iarracht eile.",
"common.processing": "Ag próiseáil...",
"loading.tip": "Molann sé go bhfanfaidh tú foighneach, tá an córas ag tosú...",

// Pagination
"pagination.showing": "Ag taispeáint {{from}} go {{to}} as {{total}} torthaí",
"pagination.previous": "Roimhe Seo",
"pagination.next": "Ar Aghaidh",
"pagination.pageOf": "Leathanach {{current}} as {{total}}",
"pagination.show": "Taispeáin",
"pagination.perPage": "in aghaidh an leathanaigh",

// Coming Soon
"comingSoon": "Ag Teacht go Luath",

// General
"language": "Teanga",
"save": "Sábháil",
"cancel": "Cealaigh",
"reset": "Athshocraigh",
"edit": "Cuir in Eagar",
"delete": "Scrios",
"create": "Cruthaigh",
"update": "Nuashonraigh",
"search": "Cuardaigh",
"filter": "Scagaire",
"all": "Gach",
"active": "Gníomhach",
"inactive": "Neamhghníomhach",
"yes": "Tá",
"no": "Níl",

// Status Labels
"status.enrolled": "Cláraithe",
"status.waitlist": "Liosta Feithimh",
"status.cancelled": "Cealaithe",

// Settings & Permissions
"settings.title": "Socruithe",
"settings.description": "Bainistigh socruithe an chórais agus cumraíochtaí",
"settings.tabs.profile": "Próifíl",
"settings.tabs.users": "Úsáideoirí",
"settings.tabs.permissions": "Ceadanna",
"settings.tabs.system": "Córas",
"settings.tabs.schoolData": "Sonraí Scoile",
"settings.tabs.fieldPermissions": "Ceadanna Réimse",

// Field Permissions
"settings.permissions.title": "Ceadanna Réimse",
"settings.permissions.description": "Cumraigh cén réimsí is féidir le gach ról úsáideora a fheiceáil agus a chur in eagar",
"settings.permissions.saveChanges": "Sábháil Athruithe",
"settings.permissions.saveSuccess": "D'éirigh le ceadanna a nuashonrú",
"settings.permissions.saveError": "Theip ar shábháil ceadanna",
"settings.permissions.noChanges": "Níl aon athruithe le sábháil",
"settings.permissions.unsavedChanges": "{{count}} athrú gan sábháil",
"settings.permissions.unsavedChanges_other": "{{count}} athruithe gan sábháil",
"settings.permissions.changesCancelled": "Athruithe curtha ar ceal",
"settings.permissions.confirmTitle": "Deimhnigh Athruithe Ceadanna",
"settings.permissions.confirmDescription": "Tá tú ar tí {{count}} cead a athrú. Rachaidh na hathruithe seo i bhfeidhm láithreach.",
"settings.permissions.confirmChanges": "Deimhnigh Athruithe",
"settings.permissions.auditLog": "Athruithe Le Déanaí",
"settings.permissions.noAuditLogs": "Níl aon athruithe le déanaí",
"settings.permissions.fieldColumn": "Réimse",
"settings.permissions.viewLabel": "Féach",
"settings.permissions.editLabel": "Cuir in Eagar",

// Field Permissions - Roles
"settings.permissions.roles.TEACHER": "Múinteoir",
"settings.permissions.roles.INTERVIEWER": "Agallóir",
"settings.permissions.roles.HOUSE_OWNER": "Úinéir Tí",
"settings.permissions.roles.PARENT": "Tuismitheoir",
"settings.permissions.roles.OFFICE": "Oifig",

// Field Permissions - Categories
"settings.permissions.categories.Administrative": "Riaracháin",
"settings.permissions.categories.Personal": "Pearsanta",
"settings.permissions.categories.Contact": "Teagmháil",
"settings.permissions.categories.Address": "Seoladh",
"settings.permissions.categories.Academic": "Acadúil",
"settings.permissions.categories.Travel": "Taisteal",
"settings.permissions.categories.Leadership": "Ceannaireacht",
"settings.permissions.categories.Friendship": "Cairdeas",
"settings.permissions.categories.Financial": "Airgeadais",
"settings.permissions.categories.Notes": "Nótaí",

// Field Permissions - Field Names
"settings.permissions.fields.student_id": "ID Dalta",
"settings.permissions.fields.status": "Stádas",
"settings.permissions.fields.upload_status": "Stádas Uaslódála",
"settings.permissions.fields.upload_issues": "Fadhbanna Uaslódála",
"settings.permissions.fields.photo_url": "Grianghraf",
"settings.permissions.fields.first_name": "Céadainm",
"settings.permissions.fields.last_name": "Sloinne",
"settings.permissions.fields.birthday": "Dáta Breithe",
"settings.permissions.fields.age": "Aois",
"settings.permissions.fields.gender": "Inscne",
"settings.permissions.fields.home_county": "Contae Baile",
"settings.permissions.fields.parent_name": "Ainm Tuismitheora/Caomhnóra",
"settings.permissions.fields.parent_email": "Ríomhphost Tuismitheora/Caomhnóra",
"settings.permissions.fields.parent_phone": "Fón Tuismitheora/Caomhnóra",
"settings.permissions.fields.student_email": "Ríomhphost an Dalta",
"settings.permissions.fields.address_1": "Líne Seolta 1",
"settings.permissions.fields.address_2": "Líne Seolta 2",
"settings.permissions.fields.address_3": "Líne Seolta 3",
"settings.permissions.fields.address_4": "Líne Seolta 4",
"settings.permissions.fields.eircode": "Éirchód",
"settings.permissions.fields.course": "Cúrsa",
"settings.permissions.fields.house": "Teach",
"settings.permissions.fields.class_group": "Grúpa Ranga",
"settings.permissions.fields.school": "Scoil",
"settings.permissions.fields.school_year": "Bliain Scoile",
"settings.permissions.fields.interview_score": "Scór Agallaimh",
"settings.permissions.fields.interview_notes": "Nótaí Agallaimh",
"settings.permissions.fields.attended_before": "D'fhreastail Roimhe",
"settings.permissions.fields.when_attended": "Cathain a D'fhreastail",
"settings.permissions.fields.travel_required": "Taisteal ag Teastáil",
"settings.permissions.fields.travel_location": "Suíomh Taistil",
"settings.permissions.fields.is_cinnire": "Cinnire (Ceannaire)",
"settings.permissions.fields.oide_username": "Oide Sannta",
"settings.permissions.fields.total_paid": "Iomlán Íoctha",
"settings.permissions.fields.balance_due": "Iarmhéid Dlite",
"settings.permissions.fields.has_friends": "Cairde Aige/Aici",
"settings.permissions.fields.friend_1_id": "ID Cara 1",
"settings.permissions.fields.friend_1_name": "Ainm Cara 1",
"settings.permissions.fields.friend_2_id": "ID Cara 2",
"settings.permissions.fields.friend_2_name": "Ainm Cara 2",
"settings.permissions.fields.friendship_list": "Liosta Cairde",
"settings.permissions.fields.notes": "Nótaí",

// Field Permissions - Descriptions
"settings.permissions.descriptions.student_id": "Aitheantóir uathúil dalta",
"settings.permissions.descriptions.status": "Stádas rollaithe an dalta",
"settings.permissions.descriptions.upload_status": "Stádas próiseála uaslódála",
"settings.permissions.descriptions.upload_issues": "Fadhbanna a aimsíodh le linn iompórtála",
"settings.permissions.descriptions.photo_url": "Grianghraf próifíle an dalta",
"settings.permissions.descriptions.first_name": "Céadainm an dalta",
"settings.permissions.descriptions.last_name": "Sloinne an dalta",
"settings.permissions.descriptions.birthday": "Dáta breithe",
"settings.permissions.descriptions.age": "Aois ríofa (inléite amháin)",
"settings.permissions.descriptions.gender": "Inscne (F/B/E)",
"settings.permissions.descriptions.home_county": "Contae cónaithe",
"settings.permissions.descriptions.parent_name": "Ainm iomlán an tuismitheora/caomhnóra",
"settings.permissions.descriptions.parent_email": "Seoladh ríomhphoist an tuismitheora/caomhnóra",
"settings.permissions.descriptions.parent_phone": "Uimhir ghutháin an tuismitheora/caomhnóra",
"settings.permissions.descriptions.address_1": "Líne seolta 1",
"settings.permissions.descriptions.address_2": "Líne seolta 2",
"settings.permissions.descriptions.address_3": "Líne seolta 3",
"settings.permissions.descriptions.address_4": "Líne seolta 4",
"settings.permissions.descriptions.eircode": "Cód poist na hÉireann",
"settings.permissions.descriptions.course": "Cúrsa rollaithe",
"settings.permissions.descriptions.house": "Teach sannta",
"settings.permissions.descriptions.class_group": "Grúpa ranga sannta",
"settings.permissions.descriptions.school": "Scoil bhaile an dalta",
"settings.permissions.descriptions.school_year": "Leibhéal bliana scoile",
"settings.permissions.descriptions.interview_score": "Scór measúnaithe agallaimh",
"settings.permissions.descriptions.interview_notes": "Nótaí agus breathnuithe agallaimh",
"settings.permissions.descriptions.attended_before": "D'fhreastail roimhe seo",
"settings.permissions.descriptions.when_attended": "Sonraí freastail roimhe seo",
"settings.permissions.descriptions.travel_required": "Socruithe taistil ag teastáil",
"settings.permissions.descriptions.travel_location": "Suíomh bailithe/fágála",
"settings.permissions.descriptions.is_cinnire": "Ról ceannaireachta",
"settings.permissions.descriptions.oide_username": "Ball foirne sannta",
"settings.permissions.descriptions.student_email": "Seoladh ríomhphoist féin an dalta",
"settings.permissions.descriptions.total_paid": "Méid iomlán íoctha (inléite amháin)",
"settings.permissions.descriptions.balance_due": "Iarmhéid gan íoc (inléite amháin)",
"settings.permissions.descriptions.has_friends": "Iarratais chairdis aige/aici",
"settings.permissions.descriptions.friend_1_id": "ID dalta cara 1 (inléite amháin)",
"settings.permissions.descriptions.friend_1_name": "Ainm iomlán cara 1 (inléite amháin)",
"settings.permissions.descriptions.friend_2_id": "ID dalta cara 2 (inléite amháin)",
"settings.permissions.descriptions.friend_2_name": "Ainm iomlán cara 2 (inléite amháin)",
"settings.permissions.descriptions.friendship_list": "Liosta cairde sa ghrúpa",
"settings.permissions.descriptions.notes": "Nótaí saorthéacs",

// Field Permissions - Audit Log Time
"settings.permissions.audit.justNow": "díreach anois",
"settings.permissions.audit.minutesAgo": "{{count}} nóiméad ó shin",
"settings.permissions.audit.minutesAgo_other": "{{count}} nóiméad ó shin",
"settings.permissions.audit.hoursAgo": "{{count}} uair ó shin",
"settings.permissions.audit.hoursAgo_other": "{{count}} uair ó shin",
"settings.permissions.audit.daysAgo": "{{count}} lá ó shin",
"settings.permissions.audit.daysAgo_other": "{{count}} lá ó shin",
"settings.permissions.audit.unknownUser": "Anaithnid",
"settings.permissions.editRequiresView": "Cumasaigh cead Féach ar dtús",
"settings.permissions.fieldReadOnly": "Réimse inléite amháin é seo",

// Page Permissions
"settings.tabs.pagePermissions": "Ceadanna Leathanaigh",
"settings.pagePermissions.title": "Ceadanna Leathanaigh",
"settings.pagePermissions.description": "Cumraigh cén leathanaigh is féidir le gach ról úsáideora a rochtain",
"settings.pagePermissions.pageColumn": "Leathanach",
"settings.pagePermissions.accessLabel": "Rochtain",
"settings.pagePermissions.saveChanges": "Sábháil Athruithe",
"settings.pagePermissions.saveSuccess": "Ceadanna leathanaigh sábháilte go rathúil",
"settings.pagePermissions.saveError": "Theip ar shábháil ceadanna leathanaigh",
"settings.pagePermissions.noChanges": "Níl aon athruithe le sábháil",
"settings.pagePermissions.unsavedChanges": "{{count}} athrú gan sábháil",
"settings.pagePermissions.unsavedChanges_other": "{{count}} athruithe gan sábháil",
"settings.pagePermissions.changesCancelled": "Athruithe curtha ar ceal",
"settings.pagePermissions.confirmTitle": "Deimhnigh Athruithe Ceadanna Leathanaigh",
"settings.pagePermissions.confirmDescription": "Tá tú ar tí {{count}} cead leathanaigh a athrú. Rachaidh na hathruithe seo i bhfeidhm láithreach.",
"settings.pagePermissions.granted": "Deonaithe",
"settings.pagePermissions.denied": "Diúltaithe",
"settings.pagePermissions.auditLog": "Athruithe Le Déanaí",
"settings.pagePermissions.noAuditLogs": "Níl aon athruithe le déanaí",

// Teimpléid Ríomhphoist
"settings.tabs.emailTemplates": "Teimpléid Ríomhphoist",
"settings.tabs.integrations": "Comhtháthuithe",
"settings.oide.title": "Comhtháthú Oide",
"settings.oide.description": "Sioncronaigh cuntais daltaí leis an ardán foghlama seachtrach Oide. Déantar daltaí a shioncronú go huathoibríoch nuair a chuirtear a seoladh ríomhphoist leis den chéad uair.",
"settings.oide.stats.synced": "Sioncronaithe",
"settings.oide.stats.pending": "Ag Fanacht le Sioncronú",
"settings.oide.stats.failed": "Theip",
"settings.oide.stats.noEmail": "Gan Ríomhphost",
"settings.oide.syncAll": "Sioncronaigh Gach Ceann Gan Sioncronú ({{count}})",
"settings.oide.bulkQueued": "Sioncronú San Scuaine",
"settings.oide.bulkQueuedMessage": "{{count}} dalta san scuaine le haghaidh sioncronaithe Oide.",
"settings.oide.bulkError": "Theip ar an scuaine sioncronaithe Oide. Déan iarracht eile.",
"settings.oide.failedHint": "Theip ar {{count}} dalta/daltaí sioncronú — seiceáil a dtaifid le haghaidh an bhratach Gníomh Ag Teastáil.",
"settings.claru.title": "Comhtháthú Claru",
"settings.claru.description": "Léargas ar éarlaisí daltaí a fuarthas ó Claru — cruthaíonn Bainisteoir an dalta agus an cuntas tuismitheora go huathoibríoch ar theacht.",
"settings.claru.stats.total": "Daltaí Faighte",
"settings.claru.stats.pendingReview": "Ag Fanacht le hAthbhreithniú",
"settings.claru.stats.none": "Ceann ar bith fós",
"settings.claru.stats.lastReceived": "Faighte is déanaí",
"settings.claru.stats.byCourse": "De réir cúrsa",
"settings.claru.stats.noneYet": "Níor fuarthas dalta ar bith trí Claru fós.",
"settings.claru.stats.pendingReviewHint": "Tá {{count}} meaitseáil dalta ag filleadh ag teastáil athbhreithniú foirne.",
"settings.claru.stats.reviewNow": "Athbhreithnigh Anois",
"identityReview.title": "Ciú Athbhreithnithe Aitheantais",
"identityReview.description": "Meaitseálacha éiginnte dalta ag filleadh ó Claru, curtha in iúl le haghaidh cinneadh foirne.",
"identityReview.remaining": "{{count}} ag fanacht",
"identityReview.empty": "Gach rud críochnaithe — níl aon rud ag fanacht le hathbhreithniú.",
"identityReview.flaggedStudent": "Dalta nua-chruthaithe",
"identityReview.flaggedHint": "Curtha in iúl {{date}} — ag meaitseáil go páirteach leis an taifead(taifid) thíos.",
"identityReview.possibleMatches": "Meaitseálacha féideartha",
"identityReview.notAMatch": "Níl ceann ar bith díobh seo — ní meaitseáil é",
"identityReview.skip": "Scip go fóill",
"identityReview.skipDisabled": "Níl aon cheann eile le scipeáil chuige",
"settings.emailTemplates.title": "Teimpléid Ríomhphoist",
"settings.emailTemplates.description": "Cuir teimpléid ríomhphoist in eagar a sheoltar chuig úsáideoirí. Úsáid sealbhóirí áite {{variable}} mar a thaispeántar i gcur síos gach teimpléad.",
"settings.emailTemplates.fetchError": "Theip ar lódáil teimpléid ríomhphoist",
"settings.emailTemplates.saveSuccess": "Teimpléad sábháilte",
"settings.emailTemplates.saveSuccessDesc": "Nuashonraíodh {{name}}.",
"settings.emailTemplates.saveError": "Theip ar shábháil teimpléad",
"settings.emailTemplates.saving": "Ag sábháil...",
"settings.emailTemplates.save": "Sábháil Teimpléad",
"settings.emailTemplates.subject": "Ábhar",
"settings.emailTemplates.body": "Corp Ríomhphoist (HTML)",
"settings.emailTemplates.bodyPlaceholder": "Scríobh an teachtaireacht ríomhphoist anseo...",
"settings.emailTemplates.noTemplates": "Níl aon teimpléid ríomhphoist le fáil.",
"settings.emailTemplates.fixedNote": "Tá an beannú agus an síniú seasta agus ní féidir iad a athrú anseo.",
"settings.emailTemplates.templates": "Teimpléid",
"settings.emailTemplates.requiredNote": "* Riachtanach i gcorp an teachtaireachta",
"settings.emailTemplates.insertVariable": "Cuir athróg isteach",
"settings.emailTemplates.missingVars": "Athróga riachtanacha in easnamh:",

// Page Permissions - Categories
"settings.pagePermissions.categories.Main": "Príomhleathanaigh",

// Page Permissions - Page Names
"settings.pagePermissions.pages.dashboard": "Deais",
"settings.pagePermissions.pages.students": "Daltaí",
"settings.pagePermissions.pages.communications": "Cumarsáid",
"settings.pagePermissions.pages.settings": "Socruithe",
"settings.pagePermissions.pages.houses": "Tithe",
"settings.pagePermissions.pages.house-allocation": "Leithdháileadh Tithe",
"settings.pagePermissions.pages.class-allocation": "Leithdháileadh Ranganna",
"settings.pagePermissions.pages.classes": "Ranganna",
"settings.pagePermissions.pages.payments": "Íocaíochtaí",
"settings.pagePermissions.pages.family-dashboard": "Deais Teaghlaigh",

// Page Permissions - Descriptions
"settings.pagePermissions.descriptions.dashboard": "Príomhdeais le hanailísíocht agus forbhreathnú",
"settings.pagePermissions.descriptions.students": "Bainistíocht agus liostú daltaí",
"settings.pagePermissions.descriptions.communications": "Cumarsáid agus feachtais ríomhphoist",
"settings.pagePermissions.descriptions.settings": "Socruithe agus cumraíocht an chórais",
"settings.pagePermissions.descriptions.houses": "Socruithe tithe agus bainistíocht acmhainneachta",
"settings.pagePermissions.descriptions.house-allocation": "Clár kanban leithdháilte tithe",
"settings.pagePermissions.descriptions.classes": "Bainistíocht grúpaí ranga",
"settings.pagePermissions.descriptions.payments": "Rianú agus próiseáil íocaíochtaí",
"settings.pagePermissions.descriptions.family-dashboard": "Deais teaghlaigh do thuismitheoirí agus do chaomhnóirí",

// School Data Management
"settings.schoolData.title": "Sonraí Scoile",
"settings.schoolData.description": "Bainistigh sonraí tagartha na scoile agus cumraíocht",
"settings.schoolData.tabs.courses": "Cúrsaí",
"settings.schoolData.tabs.travelLocations": "Suímh Taistil",
"settings.schoolData.tabs.schoolYears": "Blianta Scoile",
"settings.schoolData.travelLocations.title": "Suímh Taistil",
"settings.schoolData.travelLocations.description": "Bainistigh suímh bailithe agus fágtha na ndaltaí",
"settings.schoolData.schoolYears.title": "Blianta Scoile",
"settings.schoolData.schoolYears.description": "Bainistigh blianta acadúla agus tréimhsí seisiúin",
"settings.schoolData.comingSoon": "Ag teacht go luath...",

// System Settings
"settings.system.title": "Socruithe an Chórais",
"settings.system.description": "Cumraigh socruithe ginearálta an chórais agus praghsáil",
"settings.system.travelPrice": "Praghas Taistil",
"settings.system.travelPriceHelp": "Cuirfear an méid seo go huathoibríoch le hiarmhéid na ndaltaí a dteastaíonn socruithe taistil uathu. Ní chuireann athruithe isteach ach ar dhaltaí i gcúrsaí atá le teacht.",
"settings.system.stripeDepositFee": "Táille Éarlaise Stripe",
"settings.system.stripeDepositFeeHelp": "Beidh an táille seo aisbainte go huathoibríoch ó mhéideanna éarlaise Stripe chun críocha taispeána. Coimeádtar an méid idirbhirt bunaidh sa bhunachar sonraí.",
"settings.system.invalidStripeFee": "Cuir isteach táille bhailí Stripe (0 nó níos mó)",
"settings.system.save": "Sábháil Athruithe",
"settings.system.saving": "Á Shábháil...",
"settings.system.unsavedChanges": "Tá athruithe gan sábháil agat",
"settings.system.saveSuccess": "D'éirigh le nuashonrú socruithe an chórais",
"settings.system.saveSuccessDescription": "Tá praghas taistil nuashonraithe do chúrsaí atá le teacht.",
"settings.system.saveError": "Theip ar shábháil socruithe an chórais",
"settings.system.fetchError": "Theip ar luchtú socruithe an chórais",
"settings.system.invalidPrice": "Cuir isteach praghas bailí (0 nó níos mó)",

// Course Management
"courses.management.title": "Bainistíocht Cúrsaí",
"courses.management.description": "Bainistigh tairiscint cúrsaí, toilleadh agus praghsáil",
"courses.search.placeholder": "Cuardaigh cúrsaí de réir ainm, bliain, nó tuairisc...",
"courses.showing": "Ag taispeáint {{count}} cúrsa(í)",
"courses.noResults": "Níor aimsíodh aon chúrsaí a mheaitseálann do chuardach.",
"courses.empty": "Níl aon chúrsaí cumraithe fós. Cuir do chéad chúrsa leis le tosú.",
"courses.actions.addCourse": "Cuir Cúrsa Leis",
"courses.fields.name": "Ainm an Chúrsa",
"courses.fields.year": "Bliain",
"courses.fields.dates": "Dátaí",
"courses.fields.capacity": "Toilleadh",
"courses.fields.price": "Praghas",
"courses.fields.status": "Stádas",
"courses.fields.registered": "Cláraithe",
"courses.status.active": "Gníomhach",
"courses.status.inactive": "Neamhghníomhach",
"courses.status.completed": "Críochnaithe",
"courses.delete.title": "Scrios Cúrsa",
"courses.delete.message": "An bhfuil tú cinnte go dteastaíonn uait \"{{courseName}}\" a scriosadh? Ní féidir an gníomhaíocht seo a chealú.",
"courses.deleted": "Cúrsa Scriosta",
"courses.deleteSuccess": "Scriosadh {{name}} go rathúil.",
"courses.deleteError": "Theip ar scriosadh an chúrsa. Bain triail eile as.",
"courses.created": "Cúrsa Cruthaithe",
"courses.createSuccess": "Cruthaíodh {{name}} go rathúil.",
"courses.updated": "Cúrsa Nuashonraithe",
"courses.updateSuccess": "Nuashonraíodh {{name}} go rathúil.",
"loading.courses": "Ag lódáil cúrsaí...",
"error.loadingCourses": "Earráid ag lódáil cúrsaí. Bain triail eile as.",

// Course Archiving (Claru integration Phase 5)
"courses.archive.nudge": "Chríochnaigh \"{{courseName}}\" breis is seachtain ó shin agus tá sé réidh le cartlannú.",
"courses.archive.archiveNow": "Cartlannaigh Anois",
"courses.archive.archive": "Cartlannaigh",
"courses.archive.unarchive": "Díchartlannaigh",
"courses.archive.archivedBadge": "Cartlannaithe",
"courses.archive.dialogTitle": "Cartlannaigh Rolla an Chúrsa",
"courses.archive.unarchiveDialogTitle": "Díchartlannaigh Rolla an Chúrsa",
"courses.archive.dialogMessage": "Cartlannóidh sé seo gach dalta i \"{{courseName}}\". Fanann a gcuid taifead slán go hiomlán agus is féidir iad a athchóiriú am ar bith ag riarthóir.",
"courses.archive.unarchiveDialogMessage": "Athchóireoidh sé seo gach dalta cartlannaithe i \"{{courseName}}\" ar ais chuig an amharc oibre gníomhach.",
"courses.archive.typeToConfirm": "Clóscríobh ainm an chúrsa lena dhearbhú: {{courseName}}",
"courses.archive.passwordLabel": "Cuir d'fhocal faire isteach arís",
"courses.archive.confirmArchive": "Cartlannaigh",
"courses.archive.confirmUnarchive": "Díchartlannaigh",
"courses.archive.success": "Cúrsa Cartlannaithe",
"courses.archive.unarchiveSuccess": "Cúrsa Díchartlannaithe",
"courses.archive.successMessage": "Cartlannaíodh {{count}} dalta.",
"courses.archive.unarchiveSuccessMessage": "Athchóiríodh {{count}} dalta.",
"courses.archive.genericError": "Tharla earráid. Bain triail eile as.",
"courses.archive.showArchived": "Taispeáin cinn chartlannaithe",
"courses.archive.allHidden": "Tá mic léinn chartlannaithe ag gach cúrsa. Cuir \"Taispeáin cinn chartlannaithe\" ar siúl chun iad a fheiceáil.",

// Course Creation/Edit Modal
"courses.create.title": "Cruthaigh Cúrsa Nua",
"courses.create.description": "Cuir cúrsa nua leis an gcóras",
"courses.edit.title": "Cuir Cúrsa in Eagar", 
"courses.edit.description": "Nuashonraigh faisnéis agus socruithe an chúrsa",
"courses.form.basicInfo": "Faisnéis Bhunúsach",
"courses.form.name": "Ainm an Chúrsa",
"courses.form.namePlaceholder": "m.sh., Cúrsa Tosaitheoirí A",
"courses.form.abbreviation": "Giorrúchán",
"courses.form.abbreviationPlaceholder": "m.sh., TOS-A", 
"courses.form.abbreviationHint": "Cód gearr don chúrsa (ceannlitreacha, uimhreacha, fleiscíní)",
"courses.form.description": "Tuairisc (Roghnach)",
"courses.form.descriptionPlaceholder": "Tuairisc agus riachtanais an chúrsa...",
"courses.form.dates": "Dátaí an Chúrsa",
"courses.form.startDate": "Dáta Tosaigh",
"courses.form.endDate": "Dáta Deiridh", 
"courses.form.capacityAndPricing": "Toilleadh & Praghsáil",
"courses.form.capacity": "Toilleadh Mac Léinn",
"courses.form.capacityHint": "Uaslíon mac léinn (1-200)",
"courses.form.price": "Gnáth-Phraghas (EUR)",
"courses.form.priceHint": "Táille an chúrsa in euro",
"courses.form.cinnirePrice": "Praghas Cinnire (EUR)",
"courses.form.cinnirepPriceHint": "Táille an chúrsa do chinnirí",
"courses.fields.cinnireLabel": "(Cinnire)",
"courses.form.numClasses": "Líon Ranganna",
"courses.form.numClassesHint": "Ainmnítear ranganna Rang A, Rang B… go Rang Z (26 ar a mhéad)",
"courses.form.numClassesLocked": "Ní féidir athrú agus mic léinn sannta do ranganna",
"courses.form.create": "Cruthaigh Cúrsa",
"courses.form.update": "Nuashonraigh Cúrsa",

// Travel Locations
"travelLocations.management.title": "Suímh Taistil",
"travelLocations.management.description": "Bainistigh suímh bailithe agus fágtha na mac léinn",
"travelLocations.actions.addLocation": "Cuir Suíomh Leis",
"travelLocations.fields.name": "Ainm an tSuímh",
"travelLocations.fields.address": "Seoladh",
"travelLocations.fields.students": "Mic Léinn",
"travelLocations.fields.status": "Stádas",
"travelLocations.status.active": "Gníomhach",
"travelLocations.status.inactive": "Neamhghníomhach",
"travelLocations.empty": "Níl aon suímh taistil cumraithe fós. Cuir do chéad suíomh leis le tosú.",
"travelLocations.delete.title": "Scrios Suíomh Taistil",
"travelLocations.delete.message": "An bhfuil tú cinnte go dteastaíonn uait \"{{locationName}}\" a scriosadh? Ní féidir an gníomhaíocht seo a chealú.",
"travelLocations.deleted": "Suíomh Scriosta",
"travelLocations.deleteSuccess": "Scriosadh {{name}} go rathúil.",
"travelLocations.deleteError": "Theip ar scriosadh an tsuímh. Bain triail eile as.",
"travelLocations.created": "Suíomh Cruthaithe",
"travelLocations.createSuccess": "Cruthaíodh {{name}} go rathúil.",
"travelLocations.updated": "Suíomh Nuashonraithe",
"travelLocations.updateSuccess": "Nuashonraíodh {{name}} go rathúil.",
"travelLocations.modal.editTitle": "Cuir Suíomh Taistil in Eagar",
"travelLocations.modal.createTitle": "Cuir Suíomh Taistil Leis",
"travelLocations.modal.editDescription": "Nuashonraigh sonraí an tsuímh taistil.",
"travelLocations.modal.createDescription": "Cuir suíomh nua bailithe/fágtha leis do mhic léinn.",
"travelLocations.fields.locationName": "Ainm an tSuímh",
"travelLocations.placeholders.name": "m.sh., Aerfort Bhaile Átha Cliath, Corcaigh, Béal Feirste",
"travelLocations.fields.addressOptional": "Seoladh (Roghnach)",
"travelLocations.placeholders.address": "Seoladh mionsonraithe nó cur síos ar an bpointe cruinnithe...",
"travelLocations.fields.isActive": "Suíomh Gníomhach",
"travelLocations.fields.isActiveDescription": "Cibé an bhfuil an suíomh seo ar fáil do roghnú na mac léinn",
"travelLocations.form.create": "Cuir Suíomh Taistil Leis",
"travelLocations.form.createDescription": "Cuir suíomh nua bailithe/fágtha leis do mhic léinn.",
"travelLocations.form.update": "Nuashonraigh Suíomh Taistil",
"loading.travelLocations": "Ag lódáil suímh taistil...",
"error.loadingTravelLocations": "Earráid ag lódáil suímh taistil. Bain triail eile as.",

// School Years
"schoolYears.management.title": "Blianta Scoile",
"schoolYears.management.description": "Bainistigh blianta acadúla agus tréimhsí seisiúin",
"schoolYears.actions.addSchoolYear": "Cuir Bliain Scoile Leis",
"schoolYears.fields.year": "Bliain Scoile",
"schoolYears.fields.displayOrder": "Ord Taispeána",
"schoolYears.fields.students": "Mic Léinn",
"schoolYears.fields.status": "Stádas",
"schoolYears.status.active": "Gníomhach",
"schoolYears.status.inactive": "Neamhghníomhach",
"schoolYears.empty": "Níl aon bhlianta scoile cumraithe fós. Cuir do chéad bhliain scoile leis le tosú.",
"schoolYears.delete.title": "Scrios Bliain Scoile",
"schoolYears.delete.message": "An bhfuil tú cinnte go dteastaíonn uait \"{{schoolYearName}}\" a scriosadh? Ní féidir an gníomhaíocht seo a chealú.",
"schoolYears.deleted": "Bliain Scoile Scriosta",
"schoolYears.deleteSuccess": "Scriosadh {{year}} go rathúil.",
"schoolYears.deleteError": "Theip ar scriosadh na bliana scoile. Bain triail eile as.",
"schoolYears.created": "Bliain Scoile Cruthaithe",
"schoolYears.createSuccess": "Cruthaíodh {{year}} go rathúil.",
"schoolYears.updated": "Bliain Scoile Nuashonraithe",
"schoolYears.updateSuccess": "Nuashonraíodh {{year}} go rathúil.",
"schoolYears.modal.editTitle": "Cuir Bliain Scoile in Eagar",
"schoolYears.modal.createTitle": "Cruthaigh Bliain Scoile",
"schoolYears.modal.editDescription": "Nuashonraigh faisnéis na bliana scoile thíos.",
"schoolYears.modal.createDescription": "Cruthaigh bliain scoile nua do chlárú mac léinn.",
"schoolYears.placeholders.year": "m.sh., 1ú Bliain, 2ú Bliain, Ardteist",
"schoolYears.placeholders.displayOrder": "0",
"schoolYears.fields.isActive": "Gníomhach",
"schoolYears.fields.isActiveDescription": "Cibé an bhfuil an bhliain scoile seo inroghnaithe faoi láthair do chláruithe nua",
"loading.schoolYears": "Ag lódáil blianta scoile...",
"error.loadingSchoolYears": "Earráid ag lódáil blianta scoile. Bain triail eile as.",

// Common Actions
"common.actions": "Gníomhartha",
"common.edit": "Cuir in Eagar",
"common.delete": "Scrios",
"common.save": "Sábháil",
"common.confirm": "Deimhnigh",
"common.cancel": "Cealaigh",
"common.next": "Ar aghaidh",
"common.previous": "Ar ais",
"common.close": "Dún",
"common.moving": "Ag bogadh...",
"common.deleting": "Ag scriosadh...",
"common.unsavedChanges": "Tá athruithe gan sábháil agat. An bhfuil tú cinnte go bhfuil tú ag iarraidh imeacht?",

// Permission Management
"permissions.title": "Ceadanna Córais",
"permissions.description": "Bainistigh na ceadanna atá ar fáil sa chóras",
"permissions.create": "Cruthaigh Cead",
"permissions.search": "Cuardaigh ceadanna...",
"permissions.categories.all": "Gach Catagóir",
"permissions.categories.user_management": "Bainistíocht Úsáideoirí",
"permissions.categories.student_management": "Bainistíocht Daltaí",
"permissions.categories.course_management": "Bainistíocht Cúrsaí",
"permissions.categories.house_management": "Bainistíocht Tithe",
"permissions.categories.financial": "Airgeadais",
"permissions.categories.reports": "Tuairiscí",
"permissions.categories.system": "Riarachán Córais",
"permissions.status.active": "Gníomhach",
"permissions.status.inactive": "Neamhghníomhach",
"permissions.permissions": "ceadanna",
"permissions.displayed": "ceadanna taispeánta",
"permissions.totalActive": "gníomhach iomlán",
"permissions.noResults": "Níor aimsíodh aon cheadanna",
"permissions.tryDifferentSearch": "Bain triail as téarmaí cuardaigh difriúla",
"permissions.loading": "Ag lódáil ceadanna...",
"permissions.error": "Theip ar lódáil ceadanna",
"permissions.errorMessage": "Bhí earráid ann ag lódáil na gceadanna.",
"permissions.tryAgain": "Bain triail eile",
"permissions.comingSoon": "Ag Teacht go Luath",
"permissions.createFeature": "Cuirfear an ghné seo i bhfeidhm sa chéad chéim eile.",
"permissions.toggleFeature": "Cuirfear an ghné seo i bhfeidhm sa chéad chéim eile.",

// Role Permissions
"rolePermissions.title": "Ceadanna Róil",
"rolePermissions.description": "Sannaigh ceadanna do chineálacha úsáideoirí éagsúla",
"rolePermissions.unsavedChanges": "Tá athruithe gan shábháil agat",
"rolePermissions.save": "Sábháil",
"rolePermissions.reset": "Athshocraigh",
"rolePermissions.loading": "Ag lódáil ceadanna róil...",
"rolePermissions.error": "Theip ar lódáil ceadanna",
"rolePermissions.updated": "Ceadanna Nuashonraithe",
"rolePermissions.updateSuccess": "Nuashonraíodh ceadanna róil go rathúil.",
"rolePermissions.resetSuccess": "Cuireadh na ceadanna ar ais go dtí an staid roimhe seo.",

// User Management
"users.title": "Bainistíocht Úsáideoirí", 
"users.description": "Bainistigh úsáideoirí agus cuntais an chórais",
"users.create": "Cruthaigh Úsáideoir",
"users.newUser": "Úsáideoir Nua",
"users.search": "Cuardaigh úsáideoirí...",
"users.searchPlaceholder": "Cuardaigh úsáideoirí...",
"users.allTypes": "Gach Cineál",
"users.allStatus": "Gach Stádas",
"users.userManagement": "Bainistiócht Úsáideoirí",
"users.usersDisplayed": "úsáideoir",
"users.page": "Leathanach",
"users.of": "as",
"users.showing": "Ag taispeáint",
"users.user": "Úsáideoir",
"users.type": "Cineál",
"users.status": "Stádas",
"users.lastLogin": "Logáil Deireanach",
"users.actions": "Gníomhartha",
"users.active": "Gníomhach",
"users.inactive": "Míghníomhach",
"users.awaitingRegistration": "Ag fanacht ar chlárú",
"users.verified": "Fíoraithe",
"users.unverified": "Neamhfhíoraithe",
"users.totalUsers": "úsáideoirí iomlán",
"users.admins": "Riarthóirí",
"users.viewDetails": "Féach ar Shonraí",
"users.editUser": "Cuir in Eagar",
"users.managePermissions": "Bainistigh Ceadanna",
"users.deactivate": "Cuir as Feidhm",
"users.activate": "Cumasaigh",
"users.userDetails": "Sonraí Úsáideora",
"users.completeUserInfo": "Faisnéis iomlán don úsáideoir",
"users.personalInfo": "Faisnéis Phearsanta",
"users.systemInfo": "Faisnéis Chórais",
"users.name": "Ainm",
"users.username": "Ainm Úsáideora",
"users.email": "Ríomhphost",
"users.userType": "Cineál Úsáideora",
"users.created": "Úsáideoir Cruthaithe",
"users.loading": "Ag lódáil úsáideoirí...",
"users.failedToLoad": "Theip ar lódáil úsáideoirí",
"users.errorMessage": "Bhí earráid ann ag lódáil na n-úsáideoirí.",
"users.filter.all": "Gach Úsáideoir",
"users.filter.active": "Úsáideoirí Gníomhacha",
"users.filter.inactive": "Úsáideoirí Neamhghníomhacha",
"users.activeUsers": "úsáideoirí gníomhacha",
"users.error": "Theip ar lódáil úsáideoirí",
"users.noResults": "Níor aimsíodh aon úsáideoirí",
"users.tryDifferentSearch": "Bain triail as téarmaí cuardaigh nó scagairí difriúla",
"users.createSuccess": "Cruthaíodh úsáideoir nua go rathúil.",
"users.updated": "Úsáideoir Nuashonraithe", 
"users.updateSuccess": "Nuashonraíodh faisnéis an úsáideora go rathúil.",
"users.deleted": "Úsáideoir Scriosta",
"users.deleteSuccess": "Baineadh an t-úsáideoir ón gcóras.",
"users.createFeature": "Cuirfear cruthú úsáideoirí i bhfeidhm sa chéad chéim eile.",
"users.updateFeature": "Cuirfear eagarthóireacht úsáideoirí i bhfeidhm sa chéad chéim eile.",
"users.createNewUser": "Cruthaigh Úsáideoir Nua",
"users.createUserDescription": "Seolfar ríomhphost cuireadh chuig an úsáideoir chun a bpasfhocal a shocrú",
"users.invitationSent": "Ríomhphost cuireadh seolta chuig an úsáideoir chun a bpasfhocal a shocrú",
"users.firstName": "Ainm",
"users.lastName": "Sloinne",
"users.firstNamePlaceholder": "Seán",
"users.lastNamePlaceholder": "Ó Briain",
"users.usernamePlaceholder": "seanobriain",
"users.emailPlaceholder": "sean.obriain@sampla.ie",
"users.userCreated": "Úsáideoir Cruthaithe",
"users.creating": "Ag cruthú...",
"users.createUser": "Cruthaigh Úsáideoir",
"users.resendVerification": "Athsheol Fíorú",
"users.resendVerificationSuccess": "Athseoladh an ríomhphost fíoraithe go rathúil.",
"users.resendVerificationFailed": "Theip ar athsheoladh an ríomhphoist fíoraithe.",
"users.resendExpiredParents": "Athsheol Naisc Chuiridh Imithe as Feidhm",
"users.resendExpiredParentsChecking": "Ag seiceáil...",
"users.resendExpiredParentsSending": "Ag seoladh...",
"users.resendExpiredParentsNone": "Níl aon naisc chuiridh imithe as feidhm le hathsheoladh faoi láthair.",
"users.resendExpiredParentsCheckFailed": "Theip ar sheiceáil na naisc chuiridh imithe as feidhm.",
"users.resendExpiredParentsConfirmTitle": "Athsheol naisc chuiridh imithe as feidhm?",
"users.resendExpiredParentsConfirmDescription": "Seolfar nasc cuiridh nua chuig {{count}} tuismitheoir a bhfuil a nasc imithe as feidhm agus a bhfuil leanbh acu i gcúrsa atá le teacht. Ní oibreoidh a seannasc a thuilleadh.",
"users.resendExpiredParentsConfirmDescription_other": "Seolfar nasc cuiridh nua chuig {{count}} dtuismitheoir a bhfuil a nasc imithe as feidhm agus a bhfuil leanbh acu i gcúrsa atá le teacht. Ní oibreoidh a seannaisc a thuilleadh.",
"users.resendExpiredParentsSuccess": "Athseoladh an nasc cuiridh chuig {{count}} tuismitheoir.",
"users.resendExpiredParentsSuccess_other": "Athseoladh naisc chuiridh chuig {{count}} dtuismitheoir.",
"users.resendExpiredParentsFailed": "Theip ar athsheoladh na naisc chuiridh imithe as feidhm.",
"users.editUserDescription": "Nuashonraigh sonraí cuntas an úsáideora",
"users.saveChanges": "Sábháil Athruithe",
"users.saving": "Ag sábháil...",

// User Roles with descriptions
"userRole.ADMIN": "Riarthóir",
"userRole.ADMIN.description": "Rochtain iomlán ar an gcóras",
"userRole.TEACHER": "Múinteoir", 
"userRole.TEACHER.description": "Bainistigh daltaí agus cúrsaí",
"userRole.OFFICE": "Foireann Oifige",
"userRole.OFFICE.description": "Gnóthaí riaracháin agus íocaíochtaí", 
"userRole.HOUSE_OWNER": "Úinéir Tí",
"userRole.HOUSE_OWNER.description": "Bainistigh a dteach féin",
"userRole.INTERVIEWER": "Agallóir",
"userRole.INTERVIEWER.description": "Agallamh daltaí nua",
"userRole.PARENT": "Tuismitheoir",
"userRole.PARENT.description": "Féach ar fhaisnéis a bpáiste",

// Bainistíocht Mac Léinn (Student Management)
"students.title": "Bainistíocht Mac Léinn",
"students.description": "Bainistigh mic léinn agus a gcuid faisnéise",
"students.search": "Cuardaigh mic léinn...",
"students.searchPlaceholder": "Cuardaigh de réir ainm, ID mac léinn, ríomhphost...",
"students.allCourses": "Gach Cúrsa",
"students.allCinnire": "Gach Ceannaire",
"students.showingStudents": "Ag taispeáint {{count}} mac léinn",
"students.showingStudents_plural": "Ag taispeáint {{count}} mac léinn",
"students.fromColaiste": "ó Choláiste Lurgan",
"students.noStudentsFound": "Níor aimsíodh aon mhic léinn.",
"students.adjustFilters": "Bain triail as do chuardach nó do scagairí a choigeartú.",
"students.loadingStudents": "Ag lódáil na mac léinn...",
"students.studentId": "ID Mac Léinn",
"students.name": "Ainm",
"students.contact": "Teagmháil",
"students.interviewScore": "Scór Agallaimh",

// Painéal Scórála Agallaimh (Interview Scoring Panel)
"interview.title": "Scór Agallaimh",
"interview.score": "Scór",
"interview.notes": "Nótaí",
"interview.notesPlaceholder": "Cuir nótaí agallaimh gairid leis (140 carachtar ar a mhéid)",
"interview.save": "Sábháil Scór",
"interview.cancel": "Cealaigh",
"interview.edit": "Cuir Scór in Eagar",
"interview.addScore": "Cuir Scór Leis",
"interview.notScored": "Gan scór fós",
"interview.scoredBy": "Scóráilte ag",
"interview.locked": "Faoi Ghlas",
"interview.success.saved": "Scór Agallaimh Sábháilte",
"interview.success.savedDescription": "Taifeadadh an scór agallaimh go rathúil.",
"interview.error.scoreRequired": "Roghnaigh scór le do thoil",
"interview.error.saveFailed": "Theip ar Scór a Shábháil",

// Student List Filters
"filters.title": "Scag Mic Léinn",
"filters.description": "Mionathraigh do liosta le critéir éagsúla",
"filters.button": "Scagairí",
"filters.apply": "Cuir Scagairí i bhFeidhm",
"filters.clearAll": "Glan gach",
"filters.filterActive": "scagaire gníomhach",
"filters.filtersActive": "scagairí gníomhacha",
"filters.noFilter": "Gach",

// Filter Sections
"filters.section.student": "Mac Léinn",
"filters.section.academic": "Acadúil",
"filters.section.financial": "Airgeadais",
"filters.section.dataQuality": "Cáilíocht Sonraí",
"filters.section.campaign": "Feachtas",

// Filter Labels
"filters.status": "Stádas",
"filters.role": "Ról",
"filters.course": "Cúrsa",
"filters.friends": "Cairde",
"filters.allStatuses": "Gach",
"filters.allStudents": "Gach",
"filters.allCourses": "Gach",
"filters.cinniriOnly": "Cinnirí Amháin",
"filters.nonCinniri": "Neamh-Chinnirí",
"filters.hasFriends": "Cairde Acu",
"filters.noFriends": "Gan Chairde",
"filters.noCourses": "Níl aon chúrsaí ar fáil",

// Interview Filters
"filters.interview.title": "Céim Agallaimh",
"filters.interview.label": "Agallamh",
"filters.interview.description": "Scag de réir stádas scórála agallaimh",
"filters.interview.all": "Gach",
"filters.interview.scored": "Scóráilte",
"filters.interview.notScored": "Gan Scór",
"filters.interview.byScore": "De réir Scóir",
"filters.interview.score": "Scór",

// Payment Filters
"filters.payment.title": "Céim Íocaíochta",
"filters.payment.label": "Íocaíocht",
"filters.payment.description": "Scag de réir stádas íocaíochta",
"filters.payment.all": "Gach",
"filters.payment.fullyPaid": "Íoctha go hIomlán",
"filters.payment.outstanding": "Iarmhéid",
"filters.payment.noPayments": "Gan Íocaíochtaí",
"filters.payment.refunded": "Aisíoctha",
"filters.payment.depositOnly": "Éarlais Amháin",

// Import Filters
"filters.import": "Iompórtáil",
"filters.import.withIssues": "Le Saincheisteanna",
"filters.import.warnings": "Rabhaidh",
"filters.import.errors": "Earráidí",
"filters.import.actionRequired": "Gníomh Ag Teastáil",

// Campaign Filters
"filters.emailStatus": "Ríomhphost",
"filters.campaign.sent": "Seolta Cheana",
"filters.campaign.notSent": "Gan Seoladh",

"students.course": "Cúrsa",
"students.house": "Teach",
"students.indicators": "Táscairí",
"students.status": "Stádas",
"students.actions": "Gníomhartha",
"students.cinnire": "Cinnire",
"students.travelRequired": "Taisteal de Dhíth",
"students.hasFriends": "Cairde Acu",
"students.selectAll": "Roghnaigh Uile",
"students.selected": "roghnaithe",
"students.bulkActions": "Gníomhartha Ollmhóra",
"students.archive": "Cartlannú Roghnaithe",
"students.export": "Easpórtáil Roghnaithe",
"students.newStudent": "Mac Léinn Nua",
"students.bulkUpload": "Uaslódáil Mhór",
"students.uploadStatus.all": "Gach Cineál Uaslódála",
"students.uploadStatus.manual": "Clárú Láimhe",
"students.uploadStatus.imported": "Allmhairiú Ollmhór - Bailí",
"students.uploadStatus.withIssues": "Le Saincheisteanna (Araon)",
"students.uploadStatus.withWarnings": "Rabhaidh Amháin",
"students.uploadStatus.withErrors": "Earráidí Amháin",
"students.uploadStatus.actionRequired": "Gníomh Ag Teastáil",
"students.actionRequired": "Gníomh Ag Teastáil",
"students.importWarning": "Rabhadh Iompórtála",
"students.importError": "Earráid Iompórtála",
"students.issues": "saincheisteanna",
"students.uploadIssues.hasErrors": "Earráidí Uaslódála Aimsithe",
"students.uploadIssues.hasWarnings": "Rabhaidh Uaslódála Aimsithe",
"students.uploadIssues.hasActions": "Gníomh Ag Teastáil",
"students.uploadIssues.resolveIssue": "Scaoil",
"students.uploadIssues.markResolved": "Marcáil mar Réitithe",
"students.flag.button": "Cuir Nóta Gníomh Leis",
"students.flag.title": "Cuir Nóta Gníomh Leis",
"students.flag.description": "Cuir nóta leis ag míniú cén gníomh atá ag teastáil. Marcálfaidh sé seo an dalta mar Ghníomh Ag Teastáil agus feicfear é ina dtaifead.",
"students.flag.notePlaceholder": "Cuir síos ar an ngníomh atá ag teastáil…",
"students.flag.confirm": "Cuir Nóta Gníomh Leis",
"students.flag.success": "Dalta Marcáilte",
"students.flag.successMessage": "Marcáladh an dalta le haghaidh gníomh.",
"students.flag.error": "Theip ar mharcáil an dalta. Déan iarracht eile.",
"students.uploadIssues.confirmResolveTitle": "Marcáil Saincheisteanna mar Réitithe",
"students.uploadIssues.confirmResolve": "An bhfuil tú cinnte go dteastaíonn uait na saincheisteanna uaslódála seo a mharcáil mar réitithe? Nuashonrófar an taifead dalta gan rabhaidh iompórtála.",
"students.uploadIssues.resolved": "Saincheisteanna Réitithe",
"students.uploadIssues.resolvedMessage": "Tá saincheisteanna uaslódála marcáilte mar réitithe",
"students.uploadIssues.resolveFailed": "Theip ar réiteach saincheisteanna. Bain triail eile as le do thoil.",
"students.viewProfile": "Féach ar Phróifíl",
"students.editStudent": "Cuir Mac Léinn in Eagar",
"students.paymentHistory": "Stair Íocaíochta",
"students.payment.outstandingBalance": "Iarmhéid le hÍoc",
"students.payment.balanceDue": "€{{amount}} fós le híoc",
"students.payment.paidSoFar": "Íoctha: €{{amount}}",
"students.payment.fullyPaid": "Íoctha go hIomlán",
"students.payment.paidAmount": "Iomlán íoctha: €{{amount}}",
"students.archiveStudent": "Cartlannú Mac Léinn",
"students.age": "Aois {{age}}",
"students.notAssigned": "Gan sannadh",
"students.noContactInfo": "Gan fhaisnéis teagmhála",
"students.studentActions": "Gníomhartha Mac Léinn",
"students.ofTotal": "{{filtered}} as {{total}} mac léinn",
"students.filtered": "scagtha",
"students.total": "iomlán",
"students.clickToSort": "Cliceáil chun sórtáil",
"students.sortedAscending": "Sórtáilte in ord ardaitheach",
"students.sortedDescending": "Sórtáilte in ord íslitheach",
"students.cancel.title": "Cealaigh Clárúchán Mac Léinn",
"students.cancel.message": "An bhfuil tú cinnte go bhfuil tú ag iarraidh clárúchán {{studentName}} a chealú? Is féidir an gníomh seo a aisiompú níos déanaí trí a stádas a athrú.",
"students.cancelled": "Mac Léinn Cealaithe",
"students.cancelSuccess": "Tá {{studentName}} cealaithe go rathúil",
"students.cancelError": "Theip ar chealú an mhic léinn. Bain triail eile as le do thoil.",
"students.cancelling": "Ag cealú...",
"students.cancelEnrollment": "Cealaigh Clárúchán",
"students.updated": "Dalta Nuashonraithe",
"students.updateSuccess": "Nuashonraíodh {{studentName}} go rathúil",
"students.created": "Dalta Cláraithe",
"students.createSuccess": "Cuireadh {{studentName}} leis an gcóras",
"students.error.updateFailed": "Theip ar nuashonrú dalta",
"students.error.createFailed": "Theip ar chruthú dalta",
"students.error.loadStudentsFailed": "Theip ar luchtú daltaí",
"students.results": "toradh",
"students.stats.total": "Iomlán Daltaí",
"students.stats.active": "Gníomhach",
"students.stats.male": "Fireann",
"students.stats.female": "Baineann",
"students.reinstate.title": "Athbhunú Mac Léinn",
"students.reinstate.message": "An bhfuil tú cinnte go bhfuil tú ag iarraidh {{studentName}} a athbhunú? Athróidh a stádas ar ais go GNÍOMHACH.",
"students.reinstated": "Mac Léinn Athbhunaithe",
"students.reinstateSuccess": "Tá {{studentName}} athbhunaithe go rathúil",
"students.reinstateError": "Theip ar athbhunú an mhic léinn. Bain triail eile as le do thoil.",
"students.reinstateButton": "Athbhunú Mac Léinn",
"students.backToStudents": "Ar Ais go Mic Léinn",

// Mód Eagarthóireachta Mac Léinn (Student Edit Mode)
"students.edit.saveChanges": "Sábháil Athruithe",
"students.edit.cancelChanges": "Cealaigh Athruithe",
"students.edit.editModeActive": "Mód Eagarthóireachta Gníomhach",
"students.edit.unsavedChanges": "Athruithe gan sábháil",
"students.edit.noChanges": "Gan athruithe",
"students.edit.saving": "Á shábháil...",
"students.edit.validationErrors": "Le do thoil deisigh {{count}} earráid bailíochtaithe",
"students.edit.validationErrors_plural": "Le do thoil deisigh {{count}} earráidí bailíochtaithe",
"students.edit.editProfile": "Próifíl a Chur in Eagar",
"students.edit.edit": "Cuir in Eagar",
"students.edit.editProfileDesc": "Nuashonraigh sonraí an mhic léinn thíos",

// Lipéid Fhoirm Mac Léinn (Student Form Labels)
"students.form.firstName": "Céad Ainm",
"students.form.lastName": "Sloinne",
"students.form.studentId": "Aitheantas Mac Léinn",
"students.form.classGroup": "Grúpa Ranga",
"students.form.schoolYear": "Bliain Scoile",
"students.form.interviewScore": "Scór Agallaimh",
"students.form.previousAttendance": "Freastal Roimhe Seo",
"students.form.previouslyAttended": "Ar Fhreastal Roimhe Seo",
"students.form.studentEmail": "Ríomhphost Dalta",
"students.form.travelRequired": "Taisteal Riachtanach",
"students.form.travelLocation": "Suíomh Taistil",
"students.form.hasFriends": "Cairde",
"students.form.leadershipRole": "Ról Ceannaireachta",
"students.form.assignedStaff": "Foireann Sannta",
"students.form.addressLine1": "Líne Seolta 1",
"students.form.addressLine2": "Líne Seolta 2",
"students.form.addressLine3": "Líne Seolta 3",
"students.form.addressLine4": "Líne Seolta 4",
"students.form.eircode": "Eirchód",
"students.form.homeCounty": "Contae Baile",
"students.form.dateOfBirth": "Dáta Breithe",
"students.form.age": "Aois",
"students.form.gender": "Inscne",
"students.form.course": "Cúrsa",
"students.form.house": "Teach",
"students.form.school": "Scoil",

// Sonraí Mac Léinn - Teachtaireachtaí Bailíochtaithe (Student Detail - Validation Messages)
"students.validation.firstNameMinLength": "Caithfidh an chéad ainm a bheith 2 charachtar ar a laghad",
"students.validation.firstNameMaxLength": "Ní féidir leis an gcéad ainm níos mó ná 50 carachtar a bheith ann",
"students.validation.firstNameInvalid": "Iontráil ainm bailí le do thoil (litreacha, spásanna, fleiscíní, agus camóga amháin)",
"students.validation.lastNameMinLength": "Caithfidh an sloinne a bheith 2 charachtar ar a laghad",
"students.validation.lastNameMaxLength": "Ní féidir leis an sloinne níos mó ná 50 carachtar a bheith ann",
"students.validation.lastNameInvalid": "Iontráil ainm bailí le do thoil (litreacha, spásanna, fleiscíní, agus camóga amháin)",
"students.validation.birthdayRequired": "Tá dáta breithe riachtanach",
"students.validation.birthdayFuture": "Ní féidir leis an dáta breithe a bheith sa todhchaí",
"students.validation.parentNameRequired": "Tá ainm tuismitheora/caomhnóra riachtanach",
"students.validation.parentNameMaxLength": "Ní féidir le hainm tuismitheora/caomhnóra níos mó ná 100 carachtar a bheith ann",
"students.validation.parentNameInvalid": "Ní féidir ach litreacha, spásanna, fleiscíní, agus camóga a bheith san ainm",
"students.validation.parentEmailRequired": "Tá ríomhphost tuismitheora/caomhnóra riachtanach",
"students.validation.parentEmailInvalid": "Seoladh ríomhphoist neamhbhailí",
"students.validation.parentPhoneRequired": "Tá uimhir ghutháin tuismitheora/caomhnóra riachtanach",
"students.validation.parentPhoneInvalid": "Iontráil uimhir ghutháin bhailí le do thoil",
"students.validation.homeCountyRequired": "Tá contae baile riachtanach",
"students.validation.address1Required": "Tá líne seolta 1 riachtanach",
"students.validation.genderRequired": "Tá inscne riachtanach",
"students.validation.courseRequired": "Tá cúrsa riachtanach",
"students.validation.schoolYearRequired": "Tá bliain scoile riachtanach",
"students.validation.travelLocationRequired": "Tá suíomh taistil riachtanach nuair atá taisteal ag teastáil",

// Sonraí Mac Léinn - Lipéid Stádais (Student Detail - Status Labels)
"students.status.active": "Gníomhach",
"students.status.completed": "Críochnaithe",
"students.status.archived": "Cartlannaithe",
"students.status.cancelled": "Cealaithe",
"students.status.unknown": "Anaithnid",

// Sonraí Mac Léinn - Lipéid Suaitheantas (Student Detail - Badge Labels)
"students.badge.cinnire": "Cinnire",
"students.badge.travelRequired": "Taisteal Riachtanach",
"students.badge.hasFriends": "Cairde",
"students.badge.travel": "Taisteal",
"students.badge.friends": "Cairde",
"students.badge.placed": "Lóisteáilte",
"students.badge.yes": "Tá",
"students.badge.no": "Níl",
"students.badge.none": "Dada",
"students.badge.previouslyAttended": "Ar Fhreastal Roimhe Seo",

// Sonraí Mac Léinn - Ionadaithe (Student Detail - Placeholders)
"students.placeholders.firstName": "Céad ainm",
"students.placeholders.lastName": "Sloinne",
"students.placeholders.selectGender": "Roghnaigh inscne",
"students.placeholders.county": "Contae",
"students.placeholders.studentEmail": "Seoladh ríomhphoist dalta",
"students.placeholders.addressLine1": "Líne seolta 1",
"students.placeholders.addressLine2": "Líne seolta 2",
"students.placeholders.addressLine3": "Líne seolta 3",
"students.placeholders.addressLine4": "Líne seolta 4",
"students.placeholders.eircode": "Eirchód",
"students.placeholders.selectCourse": "Roghnaigh cúrsa",
"students.placeholders.selectSchoolYear": "Roghnaigh bliain scoile",
"students.placeholders.selectTravelLocation": "Roghnaigh suíomh taistil",
"students.placeholders.schoolName": "Ainm scoile",
"students.placeholders.addNotes": "Cuir nótaí leis faoin mac léinn...",
"students.placeholders.parentName": "Ainm tuismitheora/caomhnóra",
"students.placeholders.parentEmail": "tuismitheoir@sampla.ie",
"students.placeholders.phoneNumber": "Uimhir ghutháin",

// Sonraí Mac Léinn - Stáit Lódála & Earráidí (Student Detail - Loading & Error States)
"students.loading.details": "Sonraí mic léinn á lódáil...",
"students.error.loadFailed": "Theip ar lódáil an mhic léinn",
"students.error.loadMessage": "Bhí earráid ann agus na sonraí mic léinn á lódáil.",
"students.error.tryAgain": "Bain Triail Eile As",
"students.error.notFound": "Níor aimsíodh an mac léinn",
"students.error.notFoundMessage": "Níl an mac léinn atá á lorg agat ann nó tá sé bainte.",
"students.error.accessDenied": "Rochtain Diúltaithe",
"students.error.cannotEdit": "Ní féidir le ról {{userType}} faisnéis an mhic léinn a chur in eagar.",

// Sonraí Mac Léinn - Lipéid Coitianta & Téacs (Student Detail - Common Labels & Text)
"students.labels.studentId": "Aitheantas Mac Léinn:",
"students.labels.parentGuardian": "Tuismitheoir/Caomhnóir",
"students.labels.email": "Ríomhphost",
"students.labels.phone": "Fón",
"students.labels.status": "Stádas",
"students.labels.age": "Aois",
"students.labels.yearsOld": "bliain d'aois",
"students.labels.male": "Fireann",
"students.labels.female": "Baineann",
"students.labels.other": "Eile",
"students.labels.notSpecified": "Gan sonrú",
"students.labels.notProvided": "Gan sholáthar",
"students.labels.noDetails": "Gan sonraí ar fáil",
"students.labels.noNotes": "Gan nótaí ar fáil",
"students.labels.contactInformation": "Faisnéis Teagmhála",
"students.labels.quickStats": "Staitisticí Tapaidh",
"students.labels.edit": "Cuir in Eagar",
"students.labels.cancelEnrollment": "Cealaigh Clárú",
"students.labels.reinstateStudent": "Athbhunaigh Mac Léinn",

// Sonraí Mac Léinn - Barr Leathanach & Nascleanúint (Student Detail - Breadcrumb & Navigation)
"students.breadcrumb.students": "Mic Léinn",

// Sonraí Mac Léinn - Athruithe Gan Sábháil (Student Detail - Unsaved Changes)
"students.unsavedChanges.confirm": "Tá athruithe gan sábháil agat. An bhfuil tú cinnte go dteastaíonn uait imeacht?",
"students.unsavedChanges.discard": "Tá athruithe gan sábháil agat. An bhfuil tú cinnte go dteastaíonn uait iad a chaitheamh amach?",

// Sonraí Mac Léinn - Saincheisteanna Uaslódála (Student Detail - Upload Issues)
"students.uploadIssues.issuesCount_one": "{{count}} saincheist aimsithe le linn allmhairiú iolraí.",
"students.uploadIssues.issuesCount_other": "{{count}} saincheist aimsithe le linn allmhairiú iolraí.",
"students.uploadIssues.mayAffectAccuracy": " D'fhéadfadh na hearráidí seo difear a dhéanamh don chruinneas sonraí.",
"students.uploadIssues.pleaseReview": " Le do thoil déan athbhreithniú agus réitigh na rabhaidh seo.",
"students.uploadIssues.hide": "Folaigh",
"students.uploadIssues.show": "Taispeáin",
"students.uploadIssues.allIssues": "Gach Saincheist ({{count}})",

// Foirm Chlárúcháin Mac Léinn (Student Registration Form)
"studentReg.title": "Clárúchán Mac Léinn",
"studentReg.step": "Céim {{current}} as {{total}}",
"studentReg.personalInfo": "Faisnéis Phearsanta",
"studentReg.personalInfoDescription": "Iontráil sonraí pearsanta bunúsacha an mhic léinn",
"studentReg.addressInfo": "Faisnéis Seolta",
"studentReg.addressInfoDescription": "Seoladh baile agus sonraí suímh an mhic léinn",
"studentReg.parentContact": "Teagmháil Tuismitheora/Caomhnóra",
"studentReg.parentContactDescription": "Faisnéis teagmhála phríomhúil do thuismitheoirí/caomhnóirí",
"studentReg.academicInfo": "Faisnéis Acadúil",
"studentReg.academicInfoDescription": "Roghanna cúrsa agus ranga",
"studentReg.travelInfo": "Faisnéis Taistil",
"studentReg.travelInfoDescription": "Socruithe iompair agus taistil",
"studentReg.reviewSubmit": "Athbhreithniú & Cuir Isteach",
"studentReg.reviewSubmitDescription": "Athbhreithnigh an fhaisnéis uile roimh chur isteach",
"studentReg.previous": "Roimhe Seo",
"studentReg.next": "Ar Aghaidh",
"studentReg.submit": "Cuir Clárúchán Isteach",
"studentReg.firstName": "Céad Ainm",
"studentReg.lastName": "Sloinne",
"studentReg.irishName": "Ainm Gaeilge",
"studentReg.irishNameOptional": "Ainm Gaeilge (Roghnach)",
"studentReg.dateOfBirth": "Dáta Breithe",
"studentReg.gender": "Inscne",
"studentReg.male": "Fireann",
"studentReg.female": "Baineann",
"studentReg.other": "Eile",
"studentReg.email": "Ríomhphost",
"studentReg.mobile": "Fón Póca",
"studentReg.homePhone": "Fón Baile",
"studentReg.address": "Líne Seoladh 1",
"studentReg.address2": "Líne Seoladh 2",
"studentReg.city": "Cathair",
"studentReg.county": "Contae",
"studentReg.country": "Tír",
"studentReg.parentName": "Ainm Tuismitheora/Caomhnóra",
"studentReg.parentEmail": "Ríomhphost Tuismitheora/Caomhnóra",
"studentReg.parentPhone": "Fón Tuismitheora/Caomhnóra",
"studentReg.emergencyContact": "Teagmháil Éigeandála",
"studentReg.emergencyPhone": "Fón Éigeandála",
"studentReg.coursePreferences": "Roghanna Cúrsa",
"studentReg.housePreferences": "Roghanna Tí",
"studentReg.specialRequirements": "Riachtanais Speisialta",
"studentReg.medicalInfo": "Faisnéis Mhíochaine",
"studentReg.dietaryRequirements": "Riachtanais Aiste Bia",
"studentReg.travelLocation": "Suíomh Taistil",
"studentReg.needsTransport": "Tá Iompar de Dhíth",
"studentReg.registrationComplete": "Clárúchán Críochnaithe!",
"studentReg.processing": "Ag próiseáil an chlárúcháin...",
"studentReg.success": "Cláraíodh an mac léinn go rathúil",
"studentReg.error": "Theip ar an gclárúchán. Bain triail eile as.",

// Additional form fields (Irish)
"studentReg.school": "Scoil",
"studentReg.schoolYear": "Bliain Scoile",
"studentReg.course": "Cúrsa",
"studentReg.address3": "Líne Seoladh 3",
"studentReg.address4": "Líne Seoladh 4",
"studentReg.eircode": "Eircode",
"studentReg.attendedBefore": "Freastail Roimhe",
"studentReg.whenAttended": "Cathain a Freastail",
"studentReg.travelRequired": "Iompar Riachtanach",

// Placeholders (Irish)
"studentReg.placeholders.firstName": "Iontráil an céad ainm",
"studentReg.placeholders.lastName": "Iontráil an sloinne",
"studentReg.placeholders.address1": "Iontráil líne seolta 1",
"studentReg.placeholders.address2": "Iontráil líne seolta 2 (roghnach)",
"studentReg.placeholders.address3": "Iontráil líne seolta 3 (roghnach)",
"studentReg.placeholders.address4": "Iontráil líne seolta 4 (roghnach)",
"studentReg.placeholders.county": "Iontráil contae",
"studentReg.placeholders.eircode": "Iontráil eircode (roghnach)",
"studentReg.placeholders.parentName": "Iontráil ainm tuismitheora nó caomhnóra",
"studentReg.placeholders.parentEmail": "Iontráil ríomhphost tuismitheora nó caomhnóra",
"studentReg.placeholders.parentPhone": "Iontráil uimhir gutháin",
"studentReg.placeholders.school": "Iontráil ainm na scoile (roghnach)",
"studentReg.placeholders.whenAttended": "Iontráil cathain a d'fhreastail an mac léinn roimhe seo",
"studentReg.placeholders.selectSchoolYear": "Roghnaigh bliain scoile",
"studentReg.placeholders.selectCourse": "Roghnaigh cúrsa",
"studentReg.placeholders.selectTravelLocation": "Roghnaigh suíomh bailte",
"studentReg.placeholders.loadingSchoolYears": "Á lódáil blianta scoile...",
"studentReg.placeholders.loadingCourses": "Á lódáil cúrsaí...",
"studentReg.placeholders.loadingLocations": "Á lódáil suíomhanna...",

// Sonraí Mac Léinn (Student Detail)
"studentDetail.profile": "Próifíl Mac Léinn",
"studentDetail.overview": "Forbhreathnú",
"studentDetail.contact": "Teagmháil",
"studentDetail.academic": "Acadúil",
"studentDetail.medical": "Míochaine",
"studentDetail.travel": "Taisteal",
"studentDetail.payments": "Íocaíochtaí",
"studentDetail.communications": "Cumarsáid",
"studentDetail.basicInfo": "Faisnéis Bhunúsach",
"studentDetail.contactInfo": "Faisnéis Teagmhála",
"studentDetail.academicDetails": "Sonraí Acadúla",
"studentDetail.medicalInfo": "Faisnéis Mhíochaine",
"studentDetail.travelDetails": "Sonraí Taistil",
"studentDetail.paymentHistory": "Stair Íocaíochta",
"studentDetail.emailHistory": "Stair Ríomhphoist",
"studentDetail.noPayments": "Níl aon íocaíochtaí taifeadta",
"studentDetail.noEmails": "Níor seoladh aon ríomhphost",

// Stádas Mac Léinn (Student Statuses)
"status.ACTIVE": "Gníomhach",
"status.COMPLETED": "Críochnaithe",
"status.ARCHIVED": "Cartlannaithe",
"status.CANCELLED": "Cealaithe",

// Roghanna Inscne (Gender Options)
"gender.M": "Fireann",
"gender.F": "Baineann",
"gender.O": "Eile",
"gender.NA": "N/A",

// Cumarsáid (Communications)
"communications.title": "Cumarsáid",
"communications.dashboard": "Deais Cumarsáide",
"communications.emailDashboard": "Deais Ríomhphoist",
"communications.overview": "Forbhreathnú",
"communications.emails": "Ríomhphoist",
"communications.newEmail": "Ríomhphost Nua",
"communications.viewAnalytics": "Féach ar Anailísíocht",
"communications.recentEmails": "Ríomhphoist le Déanaí",
"communications.emailTemplates": "Teimpléid Ríomhphoist",
"communications.sendHistory": "Stair Seoladh",
"communications.totalSent": "Iomlán Seolta",
"communications.emailsSent": "Ríomhphoist Seolta",
"communications.openRate": "Ráta Oscailte",
"communications.clickRate": "Ráta Cliceála",
"communications.bounceRate": "Ráta Preabtha",
"communications.noCampaigns": "Níl aon fheachtais ann fós",
"communications.createFirst": "Cruthaigh do chéad fheachtas",
"communications.noPermission": "Níl cead agat cumarsáid a fheiceáil.",
"communications.recipients": "Faighteoirí",
"communications.deliveryRate": "Ráta Seachadta",
"communications.emailsDelivered": "Ríomhphoist seachadadh",
"communications.emailsOpened": "Ríomhphoist oscailte",
"communications.searchCampaigns": "Cuardaigh feachtais...",
"communications.allStatus": "Gach Stádas",
"communications.type": "Cineál",
"communications.subject": "Ábhar",
"communications.status": "Stádas",
"communications.sentAt": "Seolta Ag",
"communications.sentBy": "Seolta Ag",
"communications.analytics": "Anailís",
"communications.performance": "Feidhmíocht",
"communications.actions": "Gníomhartha",
"communications.date": "Dáta",
"communications.delivered": "seachadta",
"communications.opened": "oscailte",
"communications.noEmailsFound": "Níor aimsíodh ríomhphoist",
"communications.noEmailsMatchSearch": "Níor aimsíodh ríomhphoist a mheaitseálann do chuardach",
"communications.noEmailsExist": "Níl aon ríomhphoist ann fós",
"communications.createEmail": "Cruthaigh Ríomhphost",

// Additional Communications Dashboard Keys (Irish)
"communications.manageEmailsAndDrafts": "Bainistigh ríomhphoist, dréachtaí, agus anailísíocht cumarsáide",
"communications.totalEmails": "Ríomhphoist Iomlána",
"communications.sentEmails": "Ríomhphoist Seolta",
"communications.includesDrafts": "dréachtaí san áireamh",
"communications.successfullySent": "seolta go rathúil",
"communications.drafts": "Dréachtaí",
"communications.unsavedEmails": "ríomhphoist neamhsheolta",
"communications.all": "Gach",
"communications.sent": "Seolta",
"communications.draft": "Dréacht",
"communications.failed": "Theip",
"communications.createdBy": "Cruthaithe ag",
"communications.updated": "nuashonraithe",
"communications.notSent": "Ní sheol",
"communications.noperformanceData": "Níl sonraí feidhmíochta ann",
"communications.editDraft": "Cuir Dréacht in Eagar",
"communications.deleteDraft": "Scrios Dréacht",
"communications.viewEmail": "Féach ar Ríomhphost",
"communications.moreActions": "Tuilleadh Gníomhartha",
"communications.noDraftsFound": "Níor aimsíodh dréachtaí",
"communications.noDraftsMatchSearch": "Níor aimsíodh dréachtaí a mheaitseálann do chuardach",
"communications.noDraftsExist": "Níl aon dréachtaí ann fós",
"communications.createFirstDraft": "Cruthaigh an Chéad Dréacht",
"communications.manageEmails": "Bainistigh do chumarsáid ríomhphoist",
"communications.total": "iomlán",
"communications.filtered": "scagtha",
"communications.searchPlaceholder": "Cuardaigh cumarsáidí...",
"communications.allStatuses": "Gach Stádas",
"communications.allEmails": "Gach Ríomhphost",
"communications.sentOnly": "Seolta Amháin",
"communications.draftsOnly": "Dréachtaí Amháin",
"communications.created": "Cruthaithe",
"communications.noEmails": "Níor aimsíodh ríomhphoist",
"communications.createFirstEmail": "Cruthaigh do chéad ríomhphost chun tosú",
"communications.confirmDeleteTitle": "Scrios Dréacht",
"communications.confirmDeleteDescription": "An bhfuil tú cinnte gur mhaith leat an dréacht seo a scriosadh? Ní féidir an gníomh seo a chealú.",
"communications.noContentPreview": "Níl réamhamharc ábhair ar fáil don ríomhphost seo.",
"communications.contentTruncated": "Gearradh an t-ábhar go 500 carachtar.",
"communications.previewDraft": "Réamhamharc Dréacht",
"communications.previewEmail": "Réamhamharc Ríomhphoist",
"communications.emailPreview": "Réamhamharc Ríomhphoist",
"communications.sendAgain": "Seol Arís",
"communications.retryQueued": "Athiarracht sa Scuaine",
"communications.retryQueuedDescription": "Ag athiarraidh faighteoirí theipthe sa chúlra",
"communications.retrySuccess": "D'éirigh leis an Athiarracht",
"communications.retrySuccessDescription": "D'éirigh le hathiarracht ar fhaighteoirí theipthe",
"communications.retryPartialSuccess": "D'éirigh go páirteach leis an Athiarracht",
"communications.retryFailed": "Theip ar an Athiarracht",
"communications.retryFailedDescription": "Theip ar athsheol",
"communications.acknowledgeFailed": "Marcáil mar Athbhreithnithe",
"communications.acknowledgeSuccess": "Ríomhphoist Aitheanta",
"communications.acknowledgeSuccessDescription": "Ríomhphoist theipthe marcáilte mar athbhreithnithe",
"communications.acknowledgeFailedDescription": "Theip ar aitheantas ríomhphoist",
"communications.noEmailsToAcknowledge": "Níl Ríomhphoist le hAithint",
"communications.noEmailsToAcknowledgeDescription": "Níor aimsíodh ríomhphoist theipthe le haithint",
"communications.resend_edit_notice": "Ag cur athruithe ar ríomhphost roimhe — déan athruithe thíos, ansin roghnaigh faighteoirí.",

// Roghnóir Faighteoirí (Recipient Selector)
"recipients.filters": "Scagairí",
"recipients.clear": "Glan",
"recipients.clearAll": "Glan Gach Rogha",
"recipients.course": "Cúrsa",
"recipients.house": "Teach",
"recipients.class": "Rang",
"recipients.schoolYear": "Bliain Scoile",
"recipients.payment": "Íocaíocht",
"recipients.travel": "Taisteal",
"recipients.email": "Ríomhphost",
"recipients.emailToParents": "Seolfar ríomhphoist chuig seoltaí tuismitheoirí",
"recipients.emailToStudents": "Seolfar ríomhphoist chuig seoltaí mac léinn",

// Cruthú Ríomhphoist (Email Creation)
"email.title": "Ríomhphost Nua",
"email.create": "Cruthaigh Ríomhphost",
"email.createNew": "Cruthaigh Ríomhphost Nua",
"email.description": "Cruthaigh ríomhphost nua",
"email.back": "Ar ais",
"email.editor": "Eagarthóir",
"email.preview": "Réamhamharc",
"email.test": "Triail",
"email.save": "Sábháil",
"email.saveAsDraft": "Sábháil mar Dhréacht",
"email.send": "Seol",
"email.details": "Sonraí Ríomhphoist",
"email.detailsDescription": "Socraigh an bunfhaisnéis do do ríomhphost",
"email.emailType": "Cineál Ríomhphoist",
"email.emailName": "Ainm Ríomhphoist",
"email.subject": "Ábhar",
"email.sendToParents": "Seol chuig seoltaí ríomhphoist tuismitheoirí",
"email.emailContent": "Ábhar Ríomhphoist",
"email.writeContent": "Scríobh ábhar do ríomhphoist. Úsáid an taobhbharra ar dheis chun réimsí dinimiciúla a chur isteach.",
"email.recipients": "Faighteoirí",
"email.selectRecipients": "Roghnaigh Faighteoirí",
"email.recipientsDescription": "Roghnaigh cé a gheobhaidh an ríomhphost seo",
"email.emailPreview": "Réamhamharc Ríomhphoist",
"email.previewDescription": "Seo mar a fheicfidh faighteoirí do ríomhphost",
"email.previewNote": "Nóta Réamhamhairc:",
"email.sendTestEmail": "Seol Ríomhphost Triail",
"email.testDescription": "Cuir isteach seoladh ríomhphoist chun triail a sheoladh",
"email.emailAddress": "Seoladh Ríomhphoist",
"email.cancel": "Cealaigh",
"email.sending": "Ag seoladh...",
"email.selected": "roghnaithe",
"email.dynamicFieldsNote": "Beidh réimsí dinimiciúla (mar shampla {{student.first_name}}) in ionad sonraí fíor nuair a sheolfar an ríomhphost.",
"email.draftSaved": "Dréacht Sábháilte",
"email.draftSavedDescription": "Sábháladh do ríomhphost mar dhréacht go rathúil.",
"email.draftUpdated": "Dréacht Nuashonraithe",
"email.draftUpdatedDescription": "Nuashonraíodh dréacht do ríomhphoist go rathúil.",
"email.draftSaveFailed": "Theip ar Shábháil Dréacht",
"email.draftSaveFailedDescription": "Bhí earráid ag sábháil do dhréacht. Bain triail eile as.",
"email.draftDeleted": "Dréacht Scriosta",
"email.draftDeletedDescription": "Scriosadh dréacht do ríomhphoist go rathúil.",
"email.draftDeleteFailed": "Theip ar Scriosadh Dréacht",
"email.draftDeleteFailedDescription": "Bhí earráid ag scriosadh do dhréacht. Bain triail eile as.",
"email.draftLoaded": "Dréacht Luchtaithe",
"email.draftLoadedDescription": "Luchtaíodh dréacht do ríomhphoist le haghaidh eagarthóireachta.",
"email.draftLoadFailed": "Theip ar Luchtú Dréacht",
"email.draftLoadFailedDescription": "Bhí earráid ag luchtú do dhréacht. Bain triail eile as.",
"email.campaignSent": "Feachtas Ríomhphoist Seolta",
"email.campaignSentDescription": "Seoladh do ríomhphost go rathúil chuig {{count}} faighteoir(í).",
"email.campaignSendFailed": "Theip ar Sheoladh Ríomhphoist",
"email.campaignSendFailedDescription": "Bhí earráid ag seoladh do ríomhphoist. Bain triail eile as.",
"email.testSent": "Ríomhphost Tástála Seolta",
"email.testSentDescription": "Seoladh ríomhphost tástála chuig {{email}}.",
"email.testSendFailed": "Theip ar Sheoladh Ríomhphoist Tástála",
"email.testSendFailedDescription": "Bhí earráid ag seoladh an ríomhphoist tástála. Bain triail eile as.",

// Iatáin Ríomhphoist (Email Attachments)
"email.attachments": "Iatáin",
"email.addAttachment": "Cuir Iatán Leis",
"email.uploadingFile": "Comhad á uaslódáil...",
"email.fileUploaded": "D'éirigh le huaslódáil an chomhaid",
"email.uploadFailed": "Theip ar an uaslódáil",
"email.fileTooLarge": "Comhad rómhór",
"email.maxFileSize": "Uasmhéid comhaid ná {{size}}",
"email.invalidFileType": "Cineál comhaid neamhbhailí",
"email.onlyPdfAllowed": "Ní cheadaítear ach comhaid PDF",
"email.totalSizeTooLarge": "Sáraíonn méid iomlán na n-iatán an teorainn",
"email.maxTotalSize": "Uasmhéid iomlán ná {{size}}",
"email.deleteAttachment": "Scrios iatán",
"email.attachmentDeleted": "Scriosadh an t-iatán go rathúil",
"email.deleteFailed": "Theip ar scriosadh an iatáin",
"email.downloadFailed": "Theip ar íoslódáil an chomhaid",
"email.noAttachments": "Níl aon iatáin",
"email.attachmentCount": "{{count}} iatán/iatáin",
"email.saveDraftFirst": "Sábháil do dhréacht ar dtús sula gcuireann tú iatáin leis",
"email.savingDraft": "Dréacht á shábháil...",
"email.saveDraftToAddAttachments": "Sábháil Dréacht",
"email.autoSaving": "Uath-shábháil...",
"email.nowAddAttachments": "Sábháladh an dréacht! Is féidir leat iatáin a chur leis anois.",
"email.clickAgainToUpload": "Cliceáil 'Cuir Iatán Leis' arís chun do chomhad a roghnú",
"email.saveFailed": "Theip ar shábháil an dréachta",
"email.pleaseSaveManually": "Sábháil de láimh agus bain triail eile as",
"email.draftWillBeSavedAutomatically": "Sábhálfar an dréacht go huathoibríoch nuair a chuireann tú iatán leis",
"email.pdfOnlyInfo": "Comhaid PDF amháin.",
"email.maxFileSizeInfo": "Uasmhéid {{size}} in aghaidh an chomhaid.",

// Nascleanúint Draoidí (Wizard Navigation)
"wizard.page": "Leathanach",
"wizard.of": "as",
"wizard.step1of2": "Céim 1 as 2: Cruthaigh Ábhar",
"wizard.step2of2": "Céim 2 as 2: Roghnaigh Faighteoirí",
"wizard.backToContent": "Ar ais chuig an Ábhar",
"wizard.nextSelectRecipients": "Ar aghaidh: Roghnaigh Faighteoirí",
"campaign.basicInfo": "Eolas Bunúsach",
"campaign.recipients": "Faighteoirí",
"campaign.content": "Ábhar",
"campaign.preview": "Réamhradharc",
"campaign.settings": "Socruithe",
"campaign.name": "Ainm Feachtas",
"campaign.subject": "Ábhar",
"campaign.type": "Cineál",
"campaign.editContent": "Cuir Ábhar in Eagar",
"campaign.previewEmail": "Réamhradharc Ríomhphoist",
"campaign.sendTest": "Seol Tástáil",
"campaign.testEmail": "Seoladh Tástála",
"campaign.send": "Seol",
"campaign.saveDraft": "Sábháil Dréacht",
"campaign.schedule": "Sceideal",
"campaign.cancel": "Cealaigh",
"campaign.selectRecipients": "Roghnaigh Faighteoirí",
"campaign.insertField": "Cuir Réimse Isteach",
"campaign.dynamicFields": "Réimsí Dinimiciúla",
"campaign.emailLayout": "Leagan Amach Ríomhphoist",

// Cinéalacha Feachtas (Campaign Types)
"campaignType.welcome": "Fáilte",
"campaignType.reminder": "Meabhrúchán",
"campaignType.announcement": "Fógra",
"campaignType.newsletter": "Nuachtlitir",
"campaignType.marketing": "Margaíocht",
"campaignType.other": "Eile",

// Stádas Feachtas (Campaign Status)
"campaignStatus.draft": "Dréacht",
"campaignStatus.scheduled": "Sceidealaithe",
"campaignStatus.sending": "Ag Seoladh",
"campaignStatus.sent": "Seolta",
"campaignStatus.failed": "Theip",
"campaignStatus.cancelled": "Cealaithe",

// Roghnaigh Faighteoirí (Recipient Selector)
"recipients.title": "Roghnaigh Faighteoirí",
"recipients.selectAll": "Roghnaigh Uile",
"recipients.selected": "roghnaithe",
"recipients.filtered": "scagtha",
"recipients.total": "iomlán",
"recipients.outOf": "as",
"recipients.selectedCount": "{{count}} roghnaithe",
"recipients.totalStudents": "{{count}} mac léinn iomlán",
"recipients.searchPlaceholder": "Cuardaigh ainm, ID, ríomhphost...",
"recipients.allCourses": "Gach cúrsa",
"recipients.allHouses": "Gach teach",
"recipients.allClasses": "Gach rang",
"recipients.allYears": "Gach bliain",
"recipients.allStatuses": "Gach stádas",
"recipients.allLocations": "Gach ionad",
"recipients.noStudents": "Níor aimsíodh mic léinn",
"recipients.noStudentsMatch": "Níor aimsíodh mic léinn a mheaitseálann do chuardach",
"recipients.noStudentsAvailable": "Níl aon mhic léinn ar fáil",
"recipients.noEmail": "Gan ríomhphost",
"recipients.noAddress": "Gan seoladh",
"recipients.studentsSelected": "mac léinn roghnaithe don fheachtas ríomhphoist.",
"recipients.loadingStudents": "Ag lódáil mic léinn...",
"recipients.selectPage": "Roghnaigh an Leathanach",
"recipients.deselectPage": "Díroghnaigh an Leathanach",
"recipients.selectedAcrossPages": "{{count}} roghnaithe thar leathanaigh iolracha",
"recipients.results": "torthaí",
"recipients.matching": "scagairí meaitseála",
"recipients.selecting": "Ag roghnú...",
"recipients.allOnPageSelected": "Tá gach {{count}} mac léinn ar an leathanach seo roghnaithe.",
"recipients.selectAllMatchingLink": "Roghnaigh gach {{count}} mac léinn meaitseála",
"recipients.cinniriOnly": "Cinnirí Amháin",
"recipients.nonCinniri": "Neamh-Chinnirí",
"recipients.alreadySent": "Seolta Cheana",
"recipients.notSentYet": "Gan Seoladh Fós",
"common.error": "Earráid",
"common.success": "Rath",
"common.info": "Eolas",
"common.saving": "Ag sábháil...",
"common.dismiss": "Díbh",

// Stádas Íocaíochta (Payment Status)
"paymentStatus.paid": "Íoctha",
"paymentStatus.partial": "Páirteach",
"paymentStatus.pending": "Ar Feitheamh",
"paymentStatus.overdue": "Thar Am",
"paymentStatus.outstanding": "Fós le hÍoc",

// Réimsí Dinimiciúla (Dynamic Fields)
"dynamicFields.title": "Réimsí Dinimiciúla",
"dynamicFields.description": "Cliceáil chun réimsí a chur isteach sa ríomhphost",
"dynamicFields.search": "Cuardaigh réimsí...",
"dynamicFields.commonlyUsed": "Úsáidte go Minic",
"dynamicFields.insert": "Cuir isteach",
"dynamicFields.noFields": "Níor aimsíodh réimsí",
"dynamicFields.howToUse": "Conas úsáid:",
"dynamicFields.clickToInsert": "Cliceáil réimse chun é a chur isteach",
"dynamicFields.realDataReplaced": "Cuirfear sonraí fíor in ionad réimsí",
"dynamicFields.hoverToSeeCode": "Téigh thar réimsí chun a gcóid a fheiceáil",
"dynamicFields.quickInsert": "Cuir Isteach Tapa",
"dynamicFields.inserted": "curtha isteach",
"dynamicFields.buildConditional": "Tóg Ábhar Coinníollach",
"dynamicFields.conditionalDescription": "Cruthaigh teachtaireachtaí cliste le loighic má/ansin",

// Tógálaí Coinníollach (Condition Builder)
"conditionBuilder.title": "Tógálaí Ábhar Coinníollach",
"conditionBuilder.description": "Cruthaigh teachtaireachtaí cliste a thaispeánann ábhar éagsúil bunaithe ar choinníollacha. Foirfe le haghaidh ríomhphoist phearsantaithe.",
"conditionBuilder.required": "(Riachtanach)",
"conditionBuilder.selectCondition": "Roghnaigh Coinníoll",
"conditionBuilder.chooseCondition": "Roghnaigh coinníoll...",
"conditionBuilder.customCode": "Cód Coinníoll Saincheaptha",
"conditionBuilder.customHelp": "Cuir isteach comhréir choinníoll teimpléad Django",
"conditionBuilder.thenShow": "Ansin Taispeáin an Teachtaireacht Seo",
"conditionBuilder.messageExample": "Cuir isteach an teachtaireacht le taispeáint nuair atá an coinníoll seo fíor...",
"conditionBuilder.addElseIf": "Cuir Nó Má Isteach",
"conditionBuilder.addElse": "Cuir Nó Isteach (Cúltaca Roghnach)",
"conditionBuilder.otherwiseShow": "(Ar shlí eile taispeáin)",
"conditionBuilder.defaultMessage": "Teachtaireacht Réamhshocraithe",
"conditionBuilder.elseExample": "Cuir isteach an teachtaireacht le taispeáint mura bhfuil aon cheann de na coinníollacha thuas fíor...",
"conditionBuilder.showPreview": "Taispeáin Réamhamharc Cóid",
"conditionBuilder.hidePreview": "Folaigh Réamhamharc",
"conditionBuilder.insertConditional": "Cuir Ábhar Coinníollach Isteach",
"conditionBuilder.insertField": "Cuir Réimse Isteach",
"conditionBuilder.friendsTemplates": "Cairde (Teimpléid)",
"conditionBuilder.friendsList": "Liostaigh Gach Cara",
"conditionBuilder.friendsListDesc": "Liosta ainmneacha cairde le camóga eatarthu",
"conditionBuilder.friendsListBullets": "Liosta Urchair de Chairde",
"conditionBuilder.friendsListBulletsDesc": "Liosta le hurchair, cara amháin in aghaidh na líne",
"conditionBuilder.friendsCount": "Líon Cairde",
"conditionBuilder.friendsCountDesc": "Taispeánann cé mhéad cara atá acu",
"conditionBuilder.selectValue": "Roghnaigh Luach",
"conditionBuilder.chooseValue": "Roghnaigh luach...",
"conditionBuilder.schoolYearEquals": "Bliain Scoile cothrom le",
"conditionBuilder.genderEquals": "Inscne cothrom le",
"conditionBuilder.statusEquals": "Stádas cothrom le",
"conditionBuilder.interviewStatusEquals": "Stádas Agallaimh cothrom le",
"conditionBuilder.travelLocationEquals": "Suíomh Taistil cothrom le",
"conditionBuilder.courseNameEquals": "Cúrsa cothrom le",
"conditionBuilder.houseEquals": "Teach cothrom le",
"conditionBuilder.quickInsert": "Cuir Isteach Tapa:",

// Réimsí Tapa Isteach (Quick Insert Fields)
"quickField.friendsList": "Liostaigh gach cara",
"quickField.friendsBullets": "Cairde (urchair)",
"quickField.friendCount": "Líon cairde",
"quickField.balanceDue": "Iarmhéid dlite",
"quickField.totalPaid": "Iomlán íoctha",
"quickField.depositPaid": "Éarlais íoctha",
"quickField.coursePrice": "Praghas cúrsa",
"quickField.travelLocation": "Suíomh taistil",
"quickField.travelAddress": "Seoladh suímh",
"quickField.travelNotes": "Nótaí taistil",
"quickField.studentName": "Ainm mic léinn",
"quickField.parentName": "Ainm tuismitheora",
"quickField.courseName": "Ainm cúrsa",
"quickField.courseStart": "Dáta tosaigh cúrsa",
"quickField.courseEnd": "Dáta deiridh cúrsa",
"quickField.schoolYear": "Bliain scoile",
"quickField.whenAttended": "Nuair a d'fhreastail",

// Blianta Scoile (School Years)
"schoolYear.1st": "1ú Bliain",
"schoolYear.2nd": "2ú Bliain",
"schoolYear.3rd": "3ú Bliain",
"schoolYear.4th": "4ú Bliain",
"schoolYear.5th": "5ú Bliain",
"schoolYear.6th": "6ú Bliain",

// Inscne (Gender)
"gender.male": "Fireann",
"gender.female": "Baineann",

// Stádas (Status)
"status.active": "Gníomhach",
"status.withdrawn": "Tarraingthe Siar",
"status.pending": "Ar Feitheamh",

// Stádas Agallaimh (Interview Status)
"interviewStatus.notInterviewed": "Gan Agallamh",
"interviewStatus.interviewed": "Agallamh Déanta",
"interviewStatus.passed": "Pas",
"interviewStatus.failed": "Theip",

// Catagóirí Coinníoll (Condition Categories)
"conditionCategory.payment": "Íocaíocht & Airgeadas",
"conditionCategory.studentStatus": "Stádas Mac Léinn",
"conditionCategory.friends": "Cairde & Sóisialta",
"conditionCategory.travel": "Taisteal & Lóistíocht",
"conditionCategory.course": "Faisnéis Cúrsa",
"conditionCategory.specificValue": "Seiceálacha Luach Sonrach",
"conditionCategory.custom": "Coinníoll Saincheaptha",

// Roghanna Coinníoll (Condition Options)
"condition.balanceDue": "Iarmhéid Dlite (airgead dlite)",
"condition.fullyPaid": "Íoctha go hIomlán (gan iarmhéid)",
"condition.depositPaid": "Éarlais Íoctha",
"condition.depositNotPaid": "Éarlais Gan Íoc",
"condition.hasPayments": "Íocaíochtaí déanta",
"condition.noPayments": "Gan Íocaíochtaí Fós",
"condition.isCinnire": "Is Cinnire (Ceannaire)",
"condition.notCinnire": "Ní Cinnire",
"condition.attendedBefore": "Freastail Roimhe (Ag Filleadh)",
"condition.firstTime": "Ag Freastal den Chéad Uair",
"condition.statusActive": "Stádas Gníomhach",
"condition.statusWithdrawn": "Stádas Tarraingthe Siar",
"condition.hasFriends": "Cairde ag Freastal",
"condition.noFriends": "Gan Cairde ag Freastal",
"condition.travelRequired": "Taisteal Riachtanach",
"condition.noTravel": "Gan Taisteal Riachtanach",
"condition.hasTravelLocation": "Suíomh Taistil Socraithe",
"condition.hasEnrolledCourse": "Cláraithe i gCúrsa",
"condition.hasSchoolYear": "Bliain Scoile Socraithe",
"condition.custom": "Coinníoll Saincheaptha (Ardleibhéal)",

// Lipéid Réimsí - Mac Léinn (Field Labels - Student)
"field.student.firstName": "Céad Ainm",
"field.student.lastName": "Sloinne",
"field.student.fullName": "Ainm Iomlán",
"field.student.studentId": "Aitheantas Mac Léinn",
"field.student.email": "Seoladh Ríomhphoist",
"field.student.phone": "Uimhir Fóin",
"field.student.dateOfBirth": "Dáta Breithe",
"field.student.age": "Aois",
"field.student.genderCode": "Inscne (F/B)",
"field.student.genderEnglish": "Inscne (Boy/Girl)",
"field.student.genderIrish": "Inscne (Buachaill/Cailín)",
"field.student.schoolYear": "Bliain Scoile",
"field.student.currentSchool": "Scoil Reatha",
"field.student.homeCounty": "Contae Baile",

// Lipéid Réimsí - Tuismitheoir (Field Labels - Parent)
"field.parent.name": "Ainm Tuismitheora",
"field.parent.email": "Ríomhphost Tuismitheora",
"field.parent.phone": "Fón Tuismitheora",
"field.parent.emergencyContact": "Teagmhálaí Éigeandála",
"field.parent.emergencyPhone": "Fón Éigeandála",

// Lipéid Réimsí - Seoladh (Field Labels - Address)
"field.address.line1": "Líne Seolta 1",
"field.address.line2": "Líne Seolta 2",
"field.address.line3": "Líne Seolta 3",
"field.address.line4": "Líne Seolta 4",
"field.address.eircode": "Eirchód",
"field.address.city": "Cathair",
"field.address.county": "Contae",
"field.address.postalCode": "Cód Poist",
"field.address.country": "Tír",
"field.address.full": "Seoladh Iomlán",

// Lipéid Réimsí - Cúrsa (Field Labels - Course)
"field.course.name": "Ainm Cúrsa",
"field.course.startDate": "Dáta Tosaigh Cúrsa",
"field.course.endDate": "Dáta Deiridh Cúrsa",
"field.course.description": "Cur Síos ar Chúrsa",
"field.course.price": "Praghas Cúrsa (don mhac léinn seo)",
"field.house.name": "Ainm Tí",
"field.house.address": "Seoladh Tí",
"field.house.owner": "Úinéir Tí",
"field.class.name": "Ainm Ranga",
"field.class.teacher": "Múinteoir Ranga",

// Lipéid Réimsí - Taisteal (Field Labels - Travel)
"field.travel.location": "Suíomh Taistil",
"field.travel.address": "Seoladh Taistil",
"field.travel.required": "Taisteal Riachtanach",
"field.travel.notes": "Nótaí Taistil",

// Lipéid Réimsí - Airgeadais (Field Labels - Financial)
"field.financial.coursePrice": "Praghas Cúrsa (don mhac léinn seo)",
"field.financial.totalPaid": "Iomlán Íoctha",
"field.financial.balanceDue": "Iarmhéid le hÍoc",
"field.financial.depositPaid": "Éarlais Íoctha",

// Lipéid Réimsí - Córas (Field Labels - System)
"field.system.currentDate": "Dáta Reatha",
"field.system.currentYear": "Bliain Reatha",
"field.system.collegeName": "Ainm an Choláiste",
"field.system.collegeAddress": "Seoladh an Choláiste",
"field.system.collegePhone": "Fón an Choláiste",
"field.system.collegeEmail": "Ríomhphost an Choláiste",

// Catagóirí Réimsí (Field Categories)
"fieldCategory.student": "Eolas Mac Léinn",
"fieldCategory.parent": "Eolas Tuismitheora",
"fieldCategory.address": "Eolas Seoltaí",
"fieldCategory.course": "Cúrsa & Lóistín",
"fieldCategory.travel": "Eolas Taistil",
"fieldCategory.financial": "Eolas Airgeadais",
"fieldCategory.system": "Eolas Córais",

// Réimsí Mac Léinn (Student Fields)

// Réimsí Tuismitheora (Parent Fields)

// Réimsí Seoltaí (Address Fields)

// Réimsí Cúrsa (Course Fields)

// Réimsí Taistil (Travel Fields)

// Réimsí Airgeadais (Financial Fields)

// Réimsí Córais (System Fields)

// 404 Not Found Page
"notFound.title": "Leathanach Gan Aimsiú",
"notFound.message": "Níl an leathanach atá á lorg agat ann nó b'fhéidir nach bhfuil cead agat rochtain a fháil air.",
"notFound.backHome": "Ar Ais go Deais",
"notFound.goBack": "Téigh Ar Ais",
"notFound.systemName": "Córas Bainistíochta Choláiste Lurgan",

// 403 Access Denied Page
"accessDenied.title": "Rochtain Diúltaithe",
"accessDenied.message": "Níl cead agat an leathanach seo a fheiceáil. Déan teagmháil le do riarthóir má chreideann tú gur earráid é seo.",
"accessDenied.permissionsRequired": "Ceadanna Riachtanacha",
"accessDenied.userTypeRequired": "Cineál Úsáideora Riachtanach",
"accessDenied.backHome": "Ar Ais go Deais",
"accessDenied.goBack": "Téigh Ar Ais",
"accessDenied.contactAdmin": "Déan Teagmháil le Riarthóir",
"accessDenied.currentRole": "Do ról reatha:",

// 500 Server Error Page
"serverError.title": "Earráid Freastalaí",
"serverError.message": "Chuaigh rud éigin mícheart ar ár dtaobhna. Bain triail eile as i gceann cúpla nóiméad.",
"serverError.details": "Má leanann an fhadhb seo, déan teagmháil le do riarthóir córais.",
"serverError.tryAgain": "Bain Triail Eile As",
"serverError.backHome": "Ar Ais go Deais",
"serverError.reportIssue": "Tuairiscigh Fadhb",

// Network Error Page
"networkError.title": "Fadhb Ceangail",
"networkError.message": "Ní féidir ceangal leis an bhfreastalaí. Seiceáil do cheangal idirlín.",
"networkError.checkConnection": "Seiceáil do cheangal idirlín agus bain triail eile as",
"networkError.tryAgain": "Bain Triail Eile As",
"networkError.backHome": "Ar Ais go Deais",
"networkError.offline": "Is cosúil go bhfuil tú as líne",

// Maintenance Mode Page
"maintenance.title": "Cothabháil Córais",
"maintenance.message": "Tá an córas faoi chothabháil sceidealaithe faoi láthair.",
"maintenance.details": "Beimid ar ais ar líne go luath. Go raibh maith agat as d'fhoighne.",
"maintenance.estimatedTime": "Am measta críochnaithe",
"maintenance.checkBack": "Seiceáil ar ais ar ball",
"maintenance.emergency": "I gcás práinne, déan teagmháil le",

// Bulk Upload (Uaslódáil Ollmhór)
"bulkUpload.title": "Uaslódáil Mhór Daltaí",
"bulkUpload.confirmClose": "An bhfuil tú cinnte go dteastaíonn uait dúnadh? Caillfear do dhul chun cinn.",
"bulkUpload.stepProgress": "Céim {{current}} as {{total}}",

// Steps
"bulkUpload.steps.upload.title": "Uaslódáil Comhad",
"bulkUpload.steps.mapping.title": "Mapáil Réimsí",
"bulkUpload.steps.preview.title": "Réamhamharc",
"bulkUpload.steps.processing.title": "Ag Próiseáil",
"bulkUpload.steps.results.title": "Torthaí",

// Step 1: Upload
"bulkUpload.steps.upload.instructions.title": "Treoracha Uaslódála",
"bulkUpload.steps.upload.instructions.csvFormat": "Formáid CSV amháin (ionchódú UTF-8)",
"bulkUpload.steps.upload.instructions.maxSize": "Méid uasta comhaid: 10MB",
"bulkUpload.steps.upload.instructions.maxRows": "Línte uasta: 2000 dalta in aghaidh uaslódála",
"bulkUpload.steps.upload.instructions.encoding": "Cinntigh go bhfuil an comhad ionchódaithe UTF-8",
"bulkUpload.steps.upload.dropzone.title": "Scaoil comhad CSV anseo",
"bulkUpload.steps.upload.dropzone.subtitle": "nó cliceáil chun brabhsáil",
"bulkUpload.steps.upload.dropzone.button": "Roghnaigh Comhad",
"bulkUpload.steps.upload.fileInfo.size": "Méid comhaid",
"bulkUpload.steps.upload.fileInfo.rows": "Línte",
"bulkUpload.steps.upload.fileInfo.columns": "Colúin",
"bulkUpload.steps.upload.fileInfo.columnsPreview": "Ainmneacha colún",
"bulkUpload.steps.upload.success": "Comhad lódáilte go rathúil: {{count}} dalta réidh le huaslódáil",
"bulkUpload.steps.upload.next": "Ar Aghaidh: Mapáil Réimsí",

// Step 2: Mapping
"bulkUpload.steps.mapping.instructions.title": "Mapáil Réimsí",
"bulkUpload.steps.mapping.instructions.description": "Mapáil do cholúin CSV go réimsí bunachar sonraí. Tá réimsí riachtanacha marcáilte le *",
"bulkUpload.steps.mapping.stats.totalColumns": "Iomlán Colún",
"bulkUpload.steps.mapping.stats.mapped": "Mapáilte",
"bulkUpload.steps.mapping.stats.required": "Riachtanach",
"bulkUpload.steps.mapping.table.title": "Mapáil Colún",
"bulkUpload.steps.mapping.table.csvColumn": "Colún CSV",
"bulkUpload.steps.mapping.table.selectField": "Roghnaigh réimse...",
"bulkUpload.steps.mapping.table.ignore": "Déan neamhaird ar an gcolún seo",
"bulkUpload.steps.mapping.resetButton": "Athshocraigh go hUath-Bhrath",
"bulkUpload.steps.mapping.validationErrors": "Deisigh na hearráidí seo le do thoil",
"bulkUpload.steps.mapping.missingRequired.title": "Réimsí Riachtanacha ar Iarraidh ({{count}})",
"bulkUpload.steps.mapping.next": "Ar Aghaidh: Réamhamharc Sonraí",

// Step 3: Preview
"bulkUpload.steps.preview.instructions.title": "Réamhamharc & Bailíochtú",
"bulkUpload.steps.preview.instructions.description": "Athbhreithnigh sampla sonraí roimh uaslódáil. Cruthófar daltaí fiú le rabh adh - is féidir earráidí a dheisiú níos déanaí.",
"bulkUpload.steps.preview.summary.totalStudents": "Daltaí Iomlán",
"bulkUpload.steps.preview.summary.mappedFields": "Réimsí Mapáilte",
"bulkUpload.steps.preview.summary.ready": "Réidh",
"bulkUpload.steps.preview.summary.hasIssues": "Le Saincheisteanna",
"bulkUpload.steps.preview.next": "Ar Aghaidh: Tosaigh Uaslódáil",
"bulkUpload.steps.preview.warnings.largeFile": "Uaslódáil mhór: {{count}} dalta. D'fhéadfadh próiseáil cúpla nóiméad a ghlacadh.",
"bulkUpload.steps.preview.warnings.emptyColumn": "Tá colún '{{field}}' folamh",
"bulkUpload.steps.preview.table.title": "Réamhamharc Sonraí",
"bulkUpload.steps.preview.table.showing": "Ag taispeáint an chéad {{count}} as {{total}} líne",
"bulkUpload.steps.preview.table.showLess": "Taispeáin Níos Lú",
"bulkUpload.steps.preview.table.showAll": "+{{count}} colún eile",
"bulkUpload.steps.preview.notice.title": "Tábhachtach",
"bulkUpload.steps.preview.notice.description": "Cruthófar daltaí fiú má tharlaíonn earráidí bailíochtaithe. Bratófar taifid fadhbanna le hathbhreithniú láimhe.",
"bulkUpload.steps.preview.processing.title": "Am Próiseála Measta",
"bulkUpload.steps.preview.processing.estimate": "Thart ar {{seconds}} soicind",
"bulkUpload.steps.preview.startUpload": "Tosaigh Uaslódáil",

// Step 4: Processing
"bulkUpload.steps.processing.title.uploading": "Ag Uaslódáil Comhad",
"bulkUpload.steps.processing.title.processing": "Ag Próiseáil Daltaí",
"bulkUpload.steps.processing.title.success": "Uaslódáil Críochnaithe",
"bulkUpload.steps.processing.title.error": "Theip ar Uaslódáil",
"bulkUpload.steps.processing.status.uploading": "Ag uaslódáil comhad CSV chuig an bhfreastalaí...",
"bulkUpload.steps.processing.status.queued": "Uaslódáil sa scuaine, ag fanacht le tosú...",
"bulkUpload.steps.processing.status.starting": "Ag tosú próiseáil uaslódála...",
"bulkUpload.steps.processing.status.processing": "Ag próiseáil daltaí...",
"bulkUpload.steps.processing.status.completed": "Próiseáil críochnaithe go rathúil!",
"bulkUpload.steps.processing.taskId": "Aitheantas Taisc",
"bulkUpload.steps.processing.error.title": "Theip ar Uaslódáil",
"bulkUpload.steps.processing.info.title": "Ag Próiseáil Do Uaslódáil",
"bulkUpload.steps.processing.info.doNotClose": "Ná dún an fhuinneog seo le do thoil",
"bulkUpload.steps.processing.info.validation": "Ag bailíochtú sonraí daltaí agus ag seiceáil earráidí",
"bulkUpload.steps.processing.info.flagging": "Ag bratú taifid le saincheisteanna le hathbhreithniú",
"bulkUpload.steps.processing.info.payments": "Ag cruthú taifid íocaíochta nuair is infheidhme",
"bulkUpload.steps.processing.success.message": "Próiseáil uaslódála críochnaithe! Ag lódáil torthaí...",

// Step 5: Results
"bulkUpload.steps.results.subtitle": "D'uaslódáil {{count}} as {{total}} dalta go rathúil",
"bulkUpload.steps.results.stats.successful": "Foirfe",
"bulkUpload.steps.results.stats.warnings": "Le Rabhaidh",
"bulkUpload.steps.results.stats.errors": "Le hEarráidí",
"bulkUpload.steps.results.stats.failed": "Teipthe",
"bulkUpload.steps.results.details.batchId": "Aitheantas Baisce",
"bulkUpload.steps.results.details.processingTime": "Am Próiseála",
"bulkUpload.steps.results.details.successRate": "Ráta Ratha",
"bulkUpload.steps.results.issues.title": "Saincheisteanna Bailíochtaithe",
"bulkUpload.steps.results.issues.showing": "Ag taispeáint {{count}} as {{total}} saincheist",
"bulkUpload.steps.results.issues.row": "Líne",
"bulkUpload.steps.results.issues.field": "Réimse",
"bulkUpload.steps.results.issues.severity": "Cineál",
"bulkUpload.steps.results.issues.message": "Teachtaireacht",
"bulkUpload.steps.results.issues.viewMore": "+{{count}} saincheist eile (féach i mBainisteoir Saincheisteanna)",
"bulkUpload.steps.results.nextSteps.title": "Céimeanna Eile",
"bulkUpload.steps.results.nextSteps.reviewIssues": "Athbhreithnigh daltaí le rabhadh nó earráidí",
"bulkUpload.steps.results.nextSteps.filterStudents": "Scag daltaí de réir stádas uaslódála",
"bulkUpload.steps.results.nextSteps.editStudents": "Cuir taifid daltaí in eagar chun saincheisteanna a dheisiú",
"bulkUpload.steps.results.nextSteps.resolveIssues": "Marcáil saincheisteanna mar réitithe nuair atá siad socraithe",
"bulkUpload.steps.results.perfect.title": "Uaslódáil Foirfe!",
"bulkUpload.steps.results.perfect.message": "Uaslódáladh gach dalta gan aon saincheisteanna.",
"bulkUpload.steps.results.close": "Dún",
"bulkUpload.steps.results.error.noResults": "Níl torthaí uaslódála ar fáil",

// Field Names
"bulkUpload.fields.first_name": "Céad Ainm",
"bulkUpload.fields.last_name": "Sloinne",
"bulkUpload.fields.birthday": "Breithlá",
"bulkUpload.fields.gender": "Inscne",
"bulkUpload.fields.school": "Scoil",
"bulkUpload.fields.school_year": "Bliain Scoile",
"bulkUpload.fields.home_county": "Contae",
"bulkUpload.fields.attended_before": "D'fhreastail Roimhe",
"bulkUpload.fields.when_attended": "Cathain a d'fhreastail",
"bulkUpload.fields.address_1": "Líne Seolta 1",
"bulkUpload.fields.address_2": "Líne Seolta 2",
"bulkUpload.fields.address_3": "Líne Seolta 3",
"bulkUpload.fields.address_4": "Líne Seolta 4",
"bulkUpload.fields.eircode": "Eirchód",
"bulkUpload.fields.parent_name": "Ainm Tuismitheora/Caomhnóra",
"bulkUpload.fields.parent_email": "Ríomhphost Tuismitheora",
"bulkUpload.fields.parent_phone": "Fón Tuismitheora",
"bulkUpload.fields.travel_required": "Taisteal Riachtanach",
"bulkUpload.fields.travel_location": "Suíomh Taistil",
"bulkUpload.fields.course": "Cúrsa",
"bulkUpload.fields.is_cinnire": "Cinnire",
"bulkUpload.fields.payment_amount": "Méid Íocaíochta",
"bulkUpload.fields.payment_date": "Dáta Íocaíochta",
"bulkUpload.fields.payment_status": "Stádas Íocaíochta",
"bulkUpload.fields.transaction_id": "Aitheantas Idirbheart",
"bulkUpload.fields.notes": "Nótaí",

// Errors
"bulkUpload.errors.invalidFileType": "Cineál comhaid neamhbhailí. Uaslódáil comhad CSV le do thoil.",
"bulkUpload.errors.fileTooLarge": "Tá an comhad rómhór ({{size}}MB). Is é 10MB an méid uasta.",
"bulkUpload.errors.tooManyRows": "Tá {{count}} líne sa CSV. Is é {{max}} línte an líon uasta.",
"bulkUpload.errors.emptyFile": "Tá an comhad CSV folamh.",
"bulkUpload.errors.noColumns": "Níl aon cholúin sa chomhad CSV.",
"bulkUpload.errors.parseError": "Theip ar pharsáil CSV: {{message}}",
"bulkUpload.errors.requiredFieldMissing": "Níl réimse riachtanach '{{field}}' mapáilte",
"bulkUpload.errors.duplicateMapping": "Tá réimse '{{field}}' mapáilte go minic",
"bulkUpload.errors.uploadFailed": "Theip ar uaslódáil. Bain triail eile as le do thoil.",
"bulkUpload.errors.statusCheckFailed": "Theip ar sheiceáil stádas uaslódála.",
"bulkUpload.errors.processingFailed": "Theip ar phróiseáil uaslódála.",

// Cairde (Friendships)
"friendships.title": "Cairde",
"friendships.addFriend": "Cuir Cara Leis",
"friendships.addFriendTitle": "Cuir Cara Leis",
"friendships.addFriendDescription": "Roghnaigh dalta le cur leis mar chara. Caithfidh daltaí a bheith sa chúrsa céanna agus den inscne chéanna.",
"friendships.removeFriendTitle": "Bain Cara",
"friendships.removeFriendDescription": "An bhfuil tú cinnte gur mhaith leat {{name}} a bhaint mar chara?",
"friendships.searchPlaceholder": "Cuardaigh de réir ainme nó aitheantais dalta...",
"friendships.typeToSearch": "Clóscríobh chun cuardach a dhéanamh ar dhaltaí",
"friendships.typeToSearchDescription": "Iontráil 2 charachtar ar a laghad chun cuardach a thosú",
"friendships.noEligibleStudents": "Níor aimsíodh daltaí incháilithe",
"friendships.noFriends": "Gan chairde fós",
"friendships.noFriendsDescription": "Cliceáil 'Cuir Cara Leis' chun grúpaí cairdeas a chruthú",
"friendships.comingSoon": "Grúpaí cairdeas ar na gaobhair go luath",
"friendships.countOfMax": "{{count}} as {{max}}",
"friendships.removeAlsoUnlinked": "Ní bheidh {{names}} ceangailte leis an dalta seo a thuilleadh.",
"friendships.directFriend": "Cara Díreach",
"friendships.transitiveFriend": "Cara Trasteach",
"friendships.groupFull": "Tá an grúpa lán (3 dhalta ar a mhéad)",
"friendships.groupFullTitle": "Méid Uasta an Ghrúpa Bainte Amach",
"friendships.groupFullDescription": "Tá an dalta seo i ngrúpa cairdis lán cheana féin. Bain cara sula gcuireann tú ceann nua leis.",
"friendships.adding": "Á chur leis...",
"friendships.removing": "Á bhaint...",
"friendships.removeFriend": "Bain Cara",
"friendships.addSuccess": "Cuireadh cara leis go rathúil",
"friendships.addSuccessDescription": "Cruthaíodh an cairdeas",
"friendships.addError": "Theip ar chara a chur leis",
"friendships.addErrorTitle": "Earráid agus Cara á Chur Leis",
"friendships.removeSuccess": "Baineadh cara go rathúil",
"friendships.removeSuccessDescription": "Baineadh {{name}} ón liosta cairde",
"friendships.removeError": "Theip ar chara a bhaint",
"friendships.removeErrorTitle": "Earráid agus Cara á Bhaint",
"friendships.warningLabel": "Rabhadh:",
"friendships.removeWarning": "Brisfidh sé seo an nasc cairdis agus d'fhéadfadh sé tionchar a bheith aige ar shannacháin tí.",
"friendships.loadError": "Theip ar chairdis a lódáil",
"friendships.addedToGroup": "Cuireadh {{name}} leis an ngrúpa cairde",
"friendships.housePromptSubtitle": "Cara curtha leis — sannadh tí",
"friendships.housePromptTitle": "Níl {{name}} in {{house}} go fóill. Bog ann iad anois?",
"friendships.currentlyIn": "Sannadh do {{house}} cheana féin — athanfar iad",
"friendships.houseFull": "Tá {{house}} lán — níl spás ann don scoláire seo",
"friendships.houseFullHint": "Sann de láimh ón leathanach Leithdháileadh Tí nuair a bheidh spás ar fáil",
"friendships.skipHouseAssign": "Scip go fóill",
"friendships.moveToHouse": "Bog go {{house}}",
"friendships.movedToHouse": "Bogtha go {{house}}",

// Íocaíochtaí (Payments Panel)
"payments.title": "Íocaíochtaí",
"payments.addPayment": "Cuir Íocaíocht Leis",
"payments.addPaymentTitle": "Cuir Íocaíocht Leis",
"payments.addPaymentDescription": "Taifeadaigh íocaíocht nua don dalta seo",
"payments.editPaymentTitle": "Cuir Íocaíocht in Eagar",
"payments.editPaymentDescription": "Nuashonraigh sonraí na híocaíochta",
"payments.deletePaymentTitle": "Scrios Íocaíocht",
"payments.deletePaymentDescription": "An bhfuil tú cinnte gur mhaith leat an íocaíocht seo a scriosadh?",
"payments.deletePayment": "Scrios Íocaíocht",
"payments.deleteWarning": "Ní féidir an gníomh seo a chur ar ceal. Bainfear an taifead íocaíochta go buan.",
"payments.noPayments": "Gan íocaíochtaí taifeadta",
"payments.noPaymentsDescription": "Cuir an chéad íocaíocht leis chun airgeadas a rianú",
"payments.paymentHistory": "Stair Íocaíochtaí",
"payments.loadError": "Theip ar íocaíochtaí a lódáil",

// Achoimre Íocaíochta
"payments.summary.coursePrice": "Praghas an Chúrsa",
"payments.summary.additionalCharges": "Muirir Bhreise",
"payments.summary.travel": "Taisteal",
"payments.summary.totalPaid": "Iomlán Íoctha",
"payments.summary.balanceDue": "Iarmhéid Dlite",
"payments.balanceNote": "Beidh na roghanna chun iarmhéid na dtáillí a íoc ar fáil i mí Eanáir 2027.",
"payments.summary.status": "Stádas",
"payments.summary.fullyPaid": "Íoctha go hIomlán",
"payments.summary.outstanding": "Gan Íoc",
"payments.summary.overpaid": "Ró-íoctha",

// Cineálacha Íocaíochta
"payments.type.DEPOSIT": "Éarlais",
"payments.type.BALANCE": "Iarmhéid",
"payments.type.REFUND": "Aisíocaíocht",
"payments.type.ADJUSTMENT": "Coigeartú",
"payments.type.SCHOLARSHIP": "Scoláireacht",

// Stádais Íocaíochta
"payments.status.PENDING": "Ar Feitheamh",
"payments.status.PROCESSING": "Á Phróiseáil",
"payments.status.COMPLETED": "Críochnaithe",
"payments.status.FAILED": "Theip Air",
"payments.status.CANCELLED": "Cealaithe",
"payments.status.REFUNDED": "Aisíoctha",

// Modhanna Íocaíochta
"payments.method.STRIPE": "Stripe (Ar Líne)",
"payments.method.CARD": "Cárta Creidmheasa/Dochair",
"payments.method.BANK_TRANSFER": "Aistriú Bainc",
"payments.method.CASH": "Airgead Tirim",
"payments.method.CHEQUE": "Seic",
"payments.method.OTHER": "Eile",

// Scoláireacht
"payments.scholarship.provider": "Soláthraí Scoláireachta",
"payments.scholarship.providerPlaceholder": "m.sh., An Roinn Oideachais",
"payments.scholarship.type": "Cineál Scoláireachta",
"payments.scholarship.selectType": "Roghnaigh cineál",
"payments.scholarship.FULL": "Scoláireacht Iomlán",
"payments.scholarship.PARTIAL": "Scoláireacht Pháirteach",
"payments.scholarship.reference": "Tagairt Scoláireachta",
"payments.scholarship.referencePlaceholder": "Uimhir thagartha nó cód",

// Foirm Íocaíochta
"payments.form.paymentType": "Cineál Íocaíochta",
"payments.form.selectType": "Roghnaigh cineál íocaíochta",
"payments.form.amount": "Méid (EUR)",
"payments.form.paymentMethod": "Modh Íocaíochta",
"payments.form.paymentDate": "Dáta Íocaíochta",
"payments.form.status": "Stádas",
"payments.form.referenceNumber": "Uimhir Thagartha",
"payments.form.referencePlaceholder": "m.sh., INV-2026-001",
"payments.form.notes": "Nótaí",
"payments.form.notesPlaceholder": "Nótaí breise faoin íocaíocht seo...",
"payments.form.adding": "Á chur leis...",
"payments.form.saving": "Á shábháil...",
"payments.form.deleting": "Á scriosadh...",
"payments.form.saveChanges": "Sábháil Athruithe",

// Teachtaireachtaí Toast Íocaíochta
"payments.toast.addSuccess": "Cuireadh Íocaíocht Leis",
"payments.toast.addSuccessDescription": "Taifeadadh an íocaíocht go rathúil",
"payments.toast.addError": "Theip ar íocaíocht a chur leis",
"payments.toast.addErrorTitle": "Earráid agus Íocaíocht á Cur Leis",
"payments.toast.updateSuccess": "Nuashonraíodh Íocaíocht",
"payments.toast.updateSuccessDescription": "Nuashonraíodh an íocaíocht go rathúil",
"payments.toast.updateError": "Theip ar íocaíocht a nuashonrú",
"payments.toast.updateErrorTitle": "Earráid agus Íocaíocht á Nuashonrú",
"payments.toast.deleteSuccess": "Scriosadh Íocaíocht",
"payments.toast.deleteSuccessDescription": "Baineadh an íocaíocht",
"payments.toast.deleteError": "Theip ar íocaíocht a scriosadh",
"payments.toast.deleteErrorTitle": "Earráid agus Íocaíocht á Scriosadh",

// Leathanach Íocaíochtaí & Uaslódáil Ollmhór
"payments.status.ERROR": "Earráid",
"payments.page.description": "Íocaíochtaí bratacha a athbhreithniú agus comhaid CSV a iompórtáil",
"payments.page.searchResults": "{{count}} toradh/torthaí do \"{{term}}\"",
"payments.page.flaggedCount": "{{count}} íocaíocht(a) bratacha ag teastáil aird",
"payments.page.flaggedTitle": "Íocaíochtaí Bratacha",
"payments.page.uploadCsv": "Uaslódáil CSV",
"payments.page.showErrors": "Taispeáin Earráidí",
"payments.page.hideErrors": "Folaigh Earráidí",
"payments.page.searchPlaceholder": "Cuardaigh ainm, ID, ríomhphost nó tagairt...",
"payments.page.loading": "Íocaíochtaí á lódáil...",
"payments.page.error": "Theip ar íocaíochtaí a lódáil",
"payments.page.noFlagged": "Gan íocaíochtaí bratacha — glan ar fad",
"payments.page.noResults": "Gan íocaíochtaí le fáil",
"payments.page.unmatched": "Gan meaitseáil",
"payments.page.col.date": "Dáta",
"payments.page.col.student": "Dalta",
"payments.page.col.amount": "Méid",
"payments.page.col.type": "Cineál",
"payments.page.col.method": "Modh",
"payments.page.col.status": "Stádas",
"payments.page.col.flag": "Bratach",
"payments.page.col.reference": "Tagairt",
"payments.upload.title": "Iompórtáil CSV Íocaíochtaí",
"payments.upload.step1Title": "Uaslódáil",
"payments.upload.step2Title": "Réamhamharc",
"payments.upload.step3Title": "Déanta",
"payments.upload.selectFile": "Roghnaigh comhad CSV",
"payments.upload.dragDrop": "Tarraing & scaoil nó cliceáil chun roghnú",
"payments.upload.fileRequired": "Roghnaigh comhad CSV le do thoil",
"payments.upload.paymentMethod": "Modh íocaíochta",
"payments.upload.paymentMethodHint": "An modh a úsáideadh do gach íocaíocht sa chomhad",
"payments.upload.previewButton": "Réamhamharc",
"payments.upload.previewing": "Ag réamhamharc...",
"payments.upload.confirmClose": "An comhad a chaitheamh uait agus dúnadh?",
"payments.upload.previewError": "Theip ar an CSV a pharsáil — seiceáil formáid an chomhaid",
"payments.upload.noReady": "Gan íocaíochtaí réidh le hiompórtáil",
"payments.upload.noFlagged": "Gan íocaíochtaí bratacha",
"payments.upload.noUnmatched": "Gan íocaíochtaí gan meaitseáil",
"payments.upload.unmatchedWillSave": "Sábhálfar {{count}} íocaíocht(a) gan meaitseáil",
"payments.upload.unmatchedSaveExplain": "Sábháltar íocaíochtaí gan meaitseáil gan nasc dalta ionas nach gcailltear aon rud. Is féidir iad a shannadh níos déanaí ón leathanach Íocaíochtaí.",
"payments.upload.importAllButton": "Iompórtáil {{count}} íocaíocht",
"payments.upload.importAllButton_plural": "Iompórtáil {{count}} íocaíocht",
"payments.upload.importing": "Ag iompórtáil...",
"payments.upload.errorTitle": "Theip ar an iompórtáil",
"payments.upload.successTitle": "Iompórtáil críochnaithe",
"payments.upload.travelUpdated": "{{count}} dalta marcáilte le taisteal ag teastáil",
"payments.upload.travelUpdated_plural": "{{count}} dalta marcáilte le taisteal ag teastáil",
"payments.upload.skipped": "{{count}} ró caite",
"payments.upload.skipped_plural": "{{count}} róanna caite",
"payments.upload.doneButton": "Déanta",
"payments.upload.col.student": "Dalta",
"payments.upload.col.studentId": "ID",
"payments.upload.col.amount": "Méid",
"payments.upload.col.balanceDue": "Iarmhéid",
"payments.upload.col.date": "Dáta",
"payments.upload.col.flag": "Bratach",
"payments.upload.col.matchMethod": "Meaitseáilte le",
"payments.upload.col.reason": "Cúis",
"payments.upload.flag.travel_flag": "Taisteal",
"payments.upload.flag.overpayment": "Ró-íocaíocht",
"payments.upload.flag.potential_duplicate": "Dúblaigh féideartha",
"payments.upload.flag.unmatched": "Gan meaitseáil",
"payments.upload.flag.travel_flag_action": "Marcóidh iompórtáil an dalta seo le taisteal ag teastáil ({{travel}})",
"payments.upload.flag.overpayment_action": "Sáraíonn an íocaíocht an t-iarmhéid de {{excess}}",
"payments.upload.flag.overpayment_travel_mismatch": "Ní hionann an barrachas ({{excess}}) agus praghas taistil ({{travel}}) — b'fhéidir earráid sonraí",
"payments.upload.flag.potential_duplicate_action": "Tá íocaíocht den mhéid céanna ann cheana don dalta seo ar an dáta seo",
"payments.upload.match.student_id": "Uimh. Clárúcháin",
"payments.upload.match.email": "Ríomhphost",
"payments.upload.match.name": "Ainm",
"payments.resolve.title": "Réiteach Íocaíochta",
"payments.resolve.assignStudent": "Sann do dhalta",
"payments.resolve.searchStudents": "Cuardaigh daltaí...",
"payments.resolve.markResolved": "Marcáil mar Réitithe",
"payments.resolve.resolvedSuccess": "Íocaíocht réitithe",
"payments.resolve.keepPayment": "Coimeád mar atá",
"payments.resolve.keptSuccess": "Íocaíocht coimeádta",
"payments.resolve.markError": "Marcáil mar Earráid",
"payments.resolve.markErrorConfirm": "Scriosfaidh sé seo an íocaíocht go bog. An bhfuil tú cinnte?",
"payments.resolve.travelNote": "Le réiteach, marcófar an dalta seo le taisteal ag teastáil",
"payments.resolve.duplicateNote": "Cosúil le dúblaigh — fíoraigh sula gcoimeádann tú é",
"payments.resolve.duplicateKeepNote": "Má choimeádann tú é, bratacharfar cuntas an dalta le hathbhreithniú de láimh",
"payments.flag.travel_flag": "Taisteal",
"payments.flag.overpayment": "Ró-íocaíocht",
"payments.flag.potential_duplicate": "Dúblaigh féideartha",
"payments.flag.unmatched": "Gan meaitseáil",

"auditLog.title": "Loga Iniúchta",
"auditLog.description": "Lorg iniúchta slándála agus gníomhaíochta — RIARTHÓIR amháin",
"auditLog.filter.studentPlaceholder": "Cuardaigh dalta...",
"auditLog.filter.noStudents": "Gan daltaí le fáil",
"auditLog.filter.userPlaceholder": "Scag de réir ríomhphoist...",
"auditLog.filter.dateFrom": "Ó",
"auditLog.filter.dateTo": "Go",
"auditLog.col.timestamp": "Am",
"auditLog.col.user": "Úsáideoir",
"auditLog.col.action": "Gníomh",
"auditLog.col.description": "Cur Síos",
"auditLog.col.object": "Réad",
"auditLog.col.ip": "IP",
"auditLog.system": "Córas",
"auditLog.loading": "Loga iniúchta á lódáil...",
"auditLog.loadError": "Theip ar lódáil an loga iniúchta",
"auditLog.noEntries": "Gan iontrálacha le fáil",
"auditLog.noEntriesDescription": "Níl iontrálacha loga iniúchta ann a mheaitseálann na scagairí reatha",
"auditLog.entries": "iontrálacha",
"auditLog.pagination": "Leathanach {{page}} de {{totalPages}}",

"payments.tab.overview": "Forbhreathnú",
"payments.tab.flagged": "Bratacha",
"payments.overview.activeSummary": "{{students}} dalta gníomhach — {{paid}} íoctha go hiomlán, {{balance}} le hiarmhéid",
"payments.overview.addPayment": "Cuir Íocaíocht Leis",
"payments.overview.totalCollected": "Iomlán Bailithe",
"payments.overview.totalOutstanding": "Iomlán Gan Íoc",
"payments.overview.collectionRate": "Ráta Bailiúcháin",
"payments.overview.flagged": "Bratacha",
"payments.overview.students": "dalta",
"payments.overview.fullyPaid": "íoctha go hiomlán",
"payments.overview.withBalance": "le hiarmhéid",
"payments.overview.viewStudents": "Féach ar dhaltaí",
"payments.overview.requireAttention": "ag teastáil aird",
"payments.overview.allClear": "glan ar fad",
"payments.overview.byType": "De réir Cineál Íocaíochta",
"payments.overview.byMethod": "De réir Modha",
"payments.overview.noData": "Gan sonraí íocaíochta",
"payments.overview.selectStudent": "Roghnaigh Dalta",
"payments.overview.searchStudent": "Cuardaigh ainm nó ID dalta...",
"payments.overview.noStudents": "Gan daltaí le fáil",
"payments.overview.loading": "Á lódáil...",

"common.remove": "Bain",

// Leathanach Sonraí Dalta - Teidil Rannán
"students.detail.personalInfo": "Eolas Pearsanta",
"students.detail.academicInfo": "Eolas Acadúil",
"students.detail.travelLeadership": "Taisteal & Ceannaireacht",
"students.detail.notes": "Nótaí",
"students.detail.parentGuardian": "Teagmháil Tuismitheora/Caomhnóra",
"students.detail.address": "Seoladh",
"students.detail.travel": "Taisteal",

// Luachanna Coitianta
"common.yes": "Tá",
"common.no": "Níl",
"common.male": "Fireann",
"common.female": "Baineann",
"common.other": "Eile",
"common.none": "Dada",
"common.cinnire": "Cinnire",
"common.notSpecified": "Gan sonrú",
"common.notProvided": "Gan sholáthar",
"common.noDetailsProvided": "Gan sonraí ar fáil",
"common.noNotesAvailable": "Gan nótaí ar fáil",
"common.warning": "Rabhadh",
"common.optional": "roghnach",

// Ionadaitheoirí Foirme
"placeholders.firstName": "Céad ainm",
"placeholders.lastName": "Sloinne",
"placeholders.selectGender": "Roghnaigh inscne",
"placeholders.selectCourse": "Roghnaigh cúrsa",
"placeholders.selectSchoolYear": "Roghnaigh bliain scoile",
"placeholders.selectTravelLocation": "Roghnaigh suíomh taistil",
"placeholders.county": "Contae",
"placeholders.schoolName": "Ainm na scoile",
"placeholders.parentGuardianName": "Ainm tuismitheora/caomhnóra",
"placeholders.phoneNumber": "Uimhir theileafóin",
"placeholders.addressLine1": "Líne seolta 1",
"placeholders.addressLine2": "Líne seolta 2",
"placeholders.addressLine3": "Líne seolta 3",
"placeholders.addressLine4": "Líne seolta 4",
"placeholders.eircode": "Eirchód",
"placeholders.addNotes": "Cuir nótaí faoin dalta..."
    ,

// Added missing translations
"permissions.createPermission": "Cruthaigh Cead",
"permissions.createNewPermission": "Cruthaigh Cead Nua",
"permissions.addNewPermissionDescription": "Cuir cead nua leis an gcóras",
"permissions.featureComingSoon": "Cuirfear an ghné seo i bhfeidhm sa chéad chéim eile",
"permissions.noPermissionsFound": "Níor aimsíodh aon cheadanna",
"permissions.tryDifferentSearchTerms": "Bain triail as téarmaí cuardaigh éagsúla",
"permissions.permissionsDisplayed": "ceadanna ar taispeáint",
"permissions.activeInTotal": "gníomhach san iomlán",
"common.create": "Cruthaigh",
"common.tryAgain": "Bain Triail Eile As",
"common.never": "Riamh",
"communications.description": "Bainistigh feachtais ríomhphoist agus cumarsáid",
"communications.emailCampaigns": "Feachtais Ríomhphoist",
"communications.manageCampaigns": "Bainistigh feachtais",
"communications.noCampaignsFound": "Níor aimsíodh aon fheachtais",
"communications.noCampaignsExist": "Níl aon fheachtais ann fós",
"communications.createCampaign": "Cruthaigh Feachtas",
"campaign.emailTypeRequired": "Tá cineál ríomhphoist riachtanach",
"campaign.campaignName": "Ainm an Fheachtais",
"campaign.subjectRequired": "Tá ábhar riachtanach",
"campaign.sendToParents": "Seol chuig seoltaí ríomhphoist tuismitheoirí",
"campaign.emailContent": "Ábhar an Ríomhphoist",
"campaign.contentDescription": "Scríobh ábhar do ríomhphoist. Úsáid an barra taobh ar dheis chun réimsí dinimiciúla a chur isteach.",
"campaign.selected": "roghnaithe",
"campaign.recipientsRequired": "Caithfear faighteoir amháin ar a laghad a roghnú",
"campaign.emailPreview": "Réamhamharc Ríomhphoist",
"campaign.previewDescription": "Seo mar a fheicfidh faighteoirí do ríomhphost",
"campaign.previewNote": "Nóta Réamhamhairc:",
"campaign.previewNoteDynamic": "Cuirfear sonraí iarbhír in ionad réimsí dinimiciúla (cosúil le {{student.first_name}}) nuair a sheolfar an ríomhphost.",
"campaign.sending": "Ag Seoladh...",
"campaign.testEmailDescription": "Cuir isteach seoladh ríomhphoist chun tástáil a sheoladh",
"campaign.emailAddress": "Seoladh Ríomhphoist",
"dynamicFields.clickField": "Cliceáil réimse chun é a chur isteach",
"dynamicFields.realData": "Cuirfear sonraí fíora in ionad réimsí nuair a sheolfar",
"dynamicFields.studentInfo": "Faisnéis Dalta",
"dynamicFields.parentInfo": "Faisnéis Tuismitheora",
"dynamicFields.addressInfo": "Faisnéis Seolta",
"dynamicFields.courseHousing": "Cúrsa & Tithíocht",
"dynamicFields.travelInfo": "Faisnéis Taistil",
"dynamicFields.financialInfo": "Faisnéis Airgeadais",
"dynamicFields.systemInfo": "Faisnéis Córais",
"recipients.summary": "roghnaithe",
"recipients.emailTarget": "Seolfar ríomhphoist chuig seoltaí tuismitheoirí",
"recipients.emailTargetStudents": "Seolfar ríomhphoist chuig seoltaí daltaí",
// Export
"export.button": "Easpórtáil",
"export.title": "Easpórtáil Mic Léinn",
"export.description": "Roghnaigh réimsí le heaspórtáil do {{count}} mac léinn",
"export.selectedCount": "{{selected}} as {{total}} réimse roghnaithe",
"export.selectAll": "Roghnaigh Uile",
"export.deselectAll": "Díroghnaigh Uile",
"export.noFieldsSelected": "Roghnaigh réimse amháin ar a laghad le heaspórtáil",
"export.exporting": "Ag easpórtáil...",
"export.exportCSV": "Easpórtáil CSV",
"export.success": "D'éirigh le heaspórtáil {{count}} mac léinn",
"export.error": "Theip ar easpórtáil. Bain triail eile as.",
"export.sensitive": "🔒",

// Export Field Groups
"export.groups.administrative": "Riaracháin",
"export.groups.personal": "Faisnéis Phearsanta",
"export.groups.contact": "Sonraí Teagmhála",
"export.groups.address": "Faisnéis Seolta",
"export.groups.academic": "Sonraí Acadúla",
"export.groups.travel": "Faisnéis Taistil",
"export.groups.financial": "Faisnéis Airgeadais",
"export.groups.leadership": "Ceannaireacht",
"export.groups.friendship": "Grúpaí Cairdis",
"export.groups.notes": "Nótaí",
"export.groups.other": "Réimsí Eile",

// Export Field Labels - Administrative
"export.fields.student_id": "Aitheantas Uathúil",
"export.fields.status": "Stádas Clárúcháin",
"export.fields.upload_status": "Stádas Uaslódála",
"export.fields.upload_issues": "Saincheisteanna Uaslódála",

// Export Field Labels - Personal
"export.fields.photo_url": "Grianghraf Próifíle",
"export.fields.first_name": "Céad Ainm",
"export.fields.last_name": "Sloinne",
"export.fields.birthday": "Dáta Breithe",
"export.fields.age": "Aois",
"export.fields.gender": "Inscne",
"export.fields.home_county": "Contae",

// Export Field Labels - Contact
"export.fields.parent_name": "Ainm Tuismitheora/Chaomhnóra",
"export.fields.parent_email": "Ríomhphost Tuismitheora",
"export.fields.parent_phone": "Guthán Tuismitheora",

// Export Field Labels - Address
"export.fields.address_1": "Seoladh Líne 1",
"export.fields.address_2": "Seoladh Líne 2",
"export.fields.address_3": "Seoladh Líne 3",
"export.fields.address_4": "Seoladh Líne 4",
"export.fields.eircode": "Eircode",

// Export Field Labels - Academic
"export.fields.course": "Cúrsa",
"export.fields.house": "Teach",
"export.fields.class_group": "Grúpa Ranga",
"export.fields.school": "Scoil",
"export.fields.school_year": "Bliain Scoile",
"export.fields.interview_score": "Scór Agallaimh",
"export.fields.interview_notes": "Nótaí Agallaimh",
"export.fields.attended_before": "I Láthair Roimhe",
"export.fields.when_attended": "Cathain a Bhí I Láthair",

// Export Field Labels - Travel
"export.fields.travel_required": "Taisteal Riachtanach",
"export.fields.travel_location": "Suíomh Taistil",

// Export Field Labels - Financial
"export.fields.total_paid": "Méid Iomlán Íoctha",
"export.fields.balance_due": "Iarmhéid",

// Export Field Labels - Leadership
"export.fields.is_cinnire": "Cinnire",
"export.fields.oide_username": "Ball Foirne Sannta",

// Export Field Labels - Friendship
"export.fields.has_friends": "Cairde Aige",
"export.fields.friend_1_id": "Cara 1 Aitheantas Dalta",
"export.fields.friend_1_name": "Cara 1 Ainm",
"export.fields.friend_2_id": "Cara 2 Aitheantas Dalta",
"export.fields.friend_2_name": "Cara 2 Ainm",

// Export Field Labels - Notes
"export.fields.notes": "Nótaí",

// Navigation
"nav.houseAllocation": "Leithdháileadh Tithe",
"nav.cuntoirs": "Cúntóirí",

// Cúntóirí Management
"cuntoirs.title": "Cúntóirí",
"cuntoirs.description": "Bainistigh cúntóirí samhraidh agus sann iad do thithe",
"cuntoirs.addCuntoir": "Cuir Cúntóir leis",
"cuntoirs.uploadCsv": "Uaslódáil CSV",
"cuntoirs.name": "Ainm",
"cuntoirs.email": "Ríomhphost",
"cuntoirs.gender": "Inscne",
"cuntoirs.course": "Cúrsa",
"cuntoirs.house": "Teach",
"cuntoirs.unassigned": "Gan Sannú",
"cuntoirs.noData": "Níl aon Chúntóirí uaslódáilte fós",
"cuntoirs.deleteConfirm": "An bhfuil tú cinnte gur mhaith leat an Cúntóir seo a scriosadh?",
"cuntoirs.csvInstructions": "Colúin riachtanacha: first_name, last_name, gender (M/F). Roghnach: email, course (giorrúchán nó ainm).",
"cuntoirs.upload.instructions.title": "Treoracha Uaslódála",
"cuntoirs.upload.instructions.required": "Colúin riachtanacha: first_name, last_name, gender (M/F, Male/Female, Buachaill/Cailín)",
"cuntoirs.upload.instructions.optional": "Colúin roghnach: email, course (úsáid giorrúchán nó ainm iomlán an chúrsa)",
"cuntoirs.upload.instructions.csvFormat": "Formáid CSV amháin (ionchódú UTF-8)",
"cuntoirs.upload.instructions.allCourses": "Is féidir gach cúrsa a bheith i gcomhad amháin — úsáid an colún course chun gach ró a shannadh",
"cuntoirs.selectCourse": "Roghnaigh cúrsa",
"cuntoirs.uploadSuccess": "Cúntóirí uaslódáilte",
"cuntoirs.uploadSuccessDesc": "{{count}} Cúntóir(í) curtha leis go rathúil",
"cuntoirs.created": "Cúntóir curtha leis",
"cuntoirs.deleted": "Cúntóir scriosta",
"cuntoirs.updated": "Cúntóir nuashonraithe",
"cuntoirs.fields.first_name": "Céadainm",
"cuntoirs.fields.last_name": "Sloinne",
"cuntoirs.fields.gender": "Inscne",
"cuntoirs.fields.email": "Ríomhphost",
"cuntoirs.fields.course": "Cúrsa",

// House Settings
"houseSettings.title": "Socruithe Tithe",
"houseSettings.description": "Bainistigh tithe agus socraigh acmhainn agus inscne do gach cúrsa.",
"houseSettings.addHouse": "Cuir Teach Leis",
"houseSettings.saveAll": "Sábháil Uile",
"houseSettings.saveChanges": "Sábháil Athruithe",
"houseSettings.discardChanges": "Diúltaigh Athruithe",
"houseSettings.pendingChanges_one": "{{count}} athrú gan sábháil",
"houseSettings.pendingChanges_other": "{{count}} athrú gan sábháil",
"houseSettings.house": "Teach",
"houseSettings.capacity": "Acmhainn",
"houseSettings.full": "Lán",
"houseSettings.gender": "Inscne",
"houseSettings.maxCapacity": "Uasmhéid",
"houseSettings.male": "Fireann",
"houseSettings.female": "Baineann",
"houseSettings.maleAbbr": "F",
"houseSettings.femaleAbbr": "B",
"houseSettings.editHouse": "Cuir Teach in Eagar",
"houseSettings.deleteTitle": "Scrios Teach",
"houseSettings.deleteConfirm": "Bainfidh sé seo {{name}} go buan. An bhfuil tú cinnte?",
"houseSettings.deleteSuccess": "Teach scriosta",
"houseSettings.houseOwner": "Úinéir Tí",
"houseSettings.ownerName": "Ainm an Úinéara",
"houseSettings.ownerEmail": "Ríomhphost an Úinéara",
"houseSettings.ownerEmailHint": "Cruthófar cuntas nua mura bhfuil an ríomhphost seo cláraithe.",
"houseSettings.address": "Seoladh",
"houseSettings.eircode": "Eircode",
"houseSettings.mobile": "Fón Póca",
"houseSettings.landline": "Líne Talún",
"houseSettings.name": "Ainm an Tí",
"houseSettings.active": "Gníomhach",
"houseSettings.inactive": "Neamhghníomhach",
"houseSettings.saveSuccess": "Acmhainn sábháilte",
"houseSettings.houseCreated": "Teach cruthaithe",
"houseSettings.houseCreatedDesc": "Cuireadh {{name}} leis",
"houseSettings.houseUpdated": "Teach nuashonraithe",
"houseSettings.houseUpdatedDesc": "Sábháladh {{name}}",
"houseSettings.houseActivated": "Tá {{name}} gníomhach anois",
"houseSettings.houseDeactivated": "Tá {{name}} neamhghníomhach anois",
"houseSettings.deleteSuccessDesc": "Baineadh {{name}}",
"houseSettings.saveError": "Theip ar shábháil an tí",
"houseSettings.updateCoursesTitle": "Nuashonraigh Acmhainní Cúrsa",
"houseSettings.updateCoursesDesc": "Athraíodh uasacmhainn ó {{old}} go {{new}} do {{name}}. Ar mhaith leat na hacmhainní cúrsa ar fad a nuashonrú go {{new}}?",
"houseSettings.updateCoursesConfirm": "Nuashonraigh Gach Cúrsa",
"houseSettings.updateCoursesSkip": "Coinnigh Mar Atá",
"houseSettings.deleteError": "Theip ar scriosadh an tí",
"houseSettings.noUpcomingCourses": "Níl cúrsaí le teacht ann.",
"houseSettings.noHouses": "Níl tithe curtha leis fós.",
"houseSettings.summary": "Achoimre",
"houseSettings.totalBeds": "leaba ar fad",
"houseSettings.enrolled": "cláraithe",
"houseSettings.beds": "leaba",

// House Allocation Kanban
"houseAllocation.title": "Leithdháileadh Tithe",
"houseAllocation.description": "Sann mic léinn do thithe trí iad a tharraingt isteach i gcolún tí.",
"houseAllocation.selectCourse": "Roghnaigh cúrsa le tosú",
"houseAllocation.unassigned": "Gan Sannadh",
"houseAllocation.students": "Mic Léinn",
"houseAllocation.cinnire": "Cinnirí",
"houseAllocation.cuntoir": "Cúntóirí",
"houseAllocation.searchStudents": "Cuardaigh...",
"houseAllocation.male": "Fireann",
"houseAllocation.female": "Baineann",
"houseAllocation.capacity": "{{current}} / {{max}}",
"houseAllocation.full": "Lán",
"houseAllocation.readOnlyBanner": "Tá tú ag féachaint ar leithdháileadh tithe i mód léamh amháin.",
"houseAllocation.friendGroupMoved": "Grúpa cairde sannta ({{count}} mic léinn)",
"houseAllocation.friendGroupMovedDesc": "Bogadh gach ball den ghrúpa cairde le chéile.",
"houseAllocation.error.genderMismatch": "Inscne mhícheart don teach seo",
"houseAllocation.error.genderMismatchDesc": "Tá an teach seo ainmnithe d'inscne eile. Roghnaigh teach oiriúnach.",
"houseAllocation.error.capacityExceeded": "Tá an teach lán",
"houseAllocation.error.capacityExceededDesc": "Níl go leor spás sa teach seo don dalta nó don ghrúpa seo.",
"houseAllocation.noStudents": "Níl mic léinn gan sannadh",
"houseAllocation.clearAll": "Glan Gach Sannadh",
"houseAllocation.clearAllConfirm": "Bainfidh sé seo gach sannadh tí don chúrsa seo. An bhfuil tú cinnte?",
"houseAllocation.clearedAll": "Gach sannadh glan",
"houseAllocation.maleHouses": "Tithe Fireann",
"houseAllocation.femaleHouses": "Tithe Mná",
"houseAllocation.noAssigned": "Gan daltaí sannta",
"houseAllocation.progress": "{{assigned}} / {{total}} dalta sannta",
"houseAllocation.total": "Iomlán",
"houseAllocation.selectCoursePrompt": "Roghnaigh cúrsa le tosú ag leithdháileadh mac léinn do thithe.",
"houseAllocation.allCourses": "Gach Cúrsa",
"houseAllocation.complete": "Críochnaithe",
"houseAllocation.houseCount": "{{count}} teach",
"houseAllocation.clearAcknowledge": "Tuigim go mbainfeadh sé seo gach sannadh tí don chúrsa seo go buan",
"houseAllocation.clearPassword": "Deimhnigh do phasfhocal",
"houseAllocation.clearPasswordPlaceholder": "Iontráil do phasfhocal",
"houseAllocation.clearPasswordError": "Pasfhocal mícheart",
"houseAllocation.clearedAllCount": "Baineadh {{count}} dalta as a dtithe.",
"houseAllocation.clearError": "Tharla fadhb agus sannadh á ghlanadh. Déan iarracht eile.",
"houseAllocation.clearMale": "Glan Sannadh Fireann",
"houseAllocation.clearFemale": "Glan Sannadh Baineann",
"houseAllocation.clearMaleConfirm": "Bainfidh sé seo gach sannadh tí fireann don chúrsa seo. An bhfuil tú cinnte?",
"houseAllocation.clearFemaleConfirm": "Bainfidh sé seo gach sannadh tí baineann don chúrsa seo. An bhfuil tú cinnte?",
"houseAllocation.filterAllYears": "Gach bliain",
"houseAllocation.crossYearFriend": "Cara ó bhliain eile",
"students.tabs.profile": "Próifíl",
"students.tabs.housing": "Teach",
"students.tabs.friends": "Cairde",
"students.tabs.interview": "Agallamh",
"students.tabs.payments": "Íocaíochtaí",
"students.tabs.notes": "Nótaí",
"students.housing.currentAssignment": "Leithdháileadh Tí",
"students.class.currentAssignment": "Leithdháileadh Ranga",
"students.class.unassigned": "Gan Sannadh",
"students.class.changeClass": "Athraigh Rang",
"students.class.remove": "Bain",
"students.class.removeGroup": "Bain grúpa",
"students.class.selectPrompt": "Roghnaigh rang don dalta seo.",
"students.class.moveSuccess": "Sannta do {{class}}",
"students.class.unassignSuccess": "Bainte den rang",
"students.class.moveError": "Theip ar shannadh ranga",
"students.housing.unassigned": "Gan Sannadh",
"students.housing.changeHouse": "Athraigh Teach",
"students.housing.remove": "Bain",
"students.housing.removeGroup": "Bain grúpa",
"students.housing.groupGenderWarning": "Tá inscne éagsúil ag roinnt ball den ghrúpa agus ní féidir iad a shannadh don teach seo.",
"students.housing.selectPrompt": "Roghnaigh teach don dalta seo:",
"students.housing.groupMoveConfirm": "Bogfaidh sé seo an grúpa ar fad ({{count}} dalta) go {{house}}.",
"students.housing.groupUnassignConfirm": "Díshannóidh sé seo an grúpa ar fad ({{count}} dalta).",
"students.housing.groupMembers": "Grúpa",
"students.housing.moveSuccess": "Teach sannta",
"students.housing.unassignSuccess": "Dalta díshannta",
"students.housing.groupMovedDesc": "{{count}} dalta bogtha go {{house}}",
"students.housing.moveError": "Níorbh fhéidir an sannadh tí a nuashonrú",
"students.housing.errorCapacity": "Níl go leor spáis — níl an teach mór go leor don ghrúpa iomlán",
"students.housing.errorGender": "Neamhréir inscne — ní féidir na scoláirí a shannadh don teach seo",
"students.housing.friendGroup": "Grúpa Cairde",
"students.housing.groupTogether": "Le chéile",
"students.housing.groupSplit": "Scartha",
"students.housing.youSuffix": "(tú féin)",

"emailLog.title": "Stair Ríomhphoist",
"emailLog.noEmails": "Níl aon ríomhphost seolta chuig an dalta seo.",
"emailLog.columns.sentAt": "Dáta Seolta",
"emailLog.columns.subject": "Ábhar",
"emailLog.columns.type": "Cineál",
"emailLog.columns.parentEmail": "Ríomhphost Tuismitheora",
"emailLog.columns.status": "Stádas",
"emailLog.columns.sentBy": "Seolta Ag",
"emailLog.status.SENT": "Seolta",
"emailLog.status.DELIVERED": "Seachadadh",
"emailLog.status.OPENED": "Oscailte",
"emailLog.status.PENDING": "Ar Feitheamh",
"emailLog.status.FAILED": "Theip",
"emailLog.status.BOUNCED": "Preabtha",
"emailLog.status.DRAFT": "Dréacht",

"linkedHistory.title": "Stair Nasctha",
"linkedHistory.columns.course": "Cúrsa",
"linkedHistory.columns.schoolYear": "Bliain Scoile",
"linkedHistory.columns.status": "Stádas",
"linkedHistory.columns.parent": "Tuismitheoir",
"linkedHistory.columns.parentEmail": "Ríomhphost Tuismitheora",

// Class Allocation Kanban
"nav.classAllocation": "Leithdháileadh Ranganna",
"classAllocation.title": "Leithdháileadh Ranganna",
"classAllocation.description": "Sann daltaí do ghrúpaí ranga trí iad a tharraingt isteach i ranga.",
"classAllocation.selectCoursePrompt": "Roghnaigh cúrsa chun tús a chur le leithdháileadh ranganna.",
"classAllocation.allCourses": "Gach Cúrsa",
"classAllocation.unassigned": "Gan Sannadh",
"classAllocation.searchStudents": "Cuardach...",
"classAllocation.filterByYear": "Bliain",
"classAllocation.filterAllYears": "Gach Bliain",
"classAllocation.noStudents": "Níl daltaí gan sannadh",
"classAllocation.noAssigned": "Níl daltaí sannta",
"classAllocation.students": "Daltaí",
"classAllocation.cinnire": "Cinnirí",
"classAllocation.total": "Iomlán",
"classAllocation.complete": "Críochnaithe",
"classAllocation.classes": "Ranganna",
"classAllocation.studentsAssigned": "Daltaí sannta",
"classAllocation.full": "Lán",
"classAllocation.cinnireClass": "Rang na gCinnirí",
"classAllocation.classCount": "{{count}} rang",
"classAllocation.assigned": "{{assigned}} / {{total}} sannta",
"classAllocation.autoAssign": "Uath-Shannadh",
"classAllocation.autoAssigning": "Ag sannadh...",
"classAllocation.autoAssignConfirm": "Leithdháilfidh uath-shannadh daltaí gan sannadh isteach i ranganna, ag cloí le blianta scoile, cothromaíocht inscne (70/30), scaipeadh tithe, agus grúpaí cairde.",
"classAllocation.autoAssignReassignAll": "Athshann gach dalta (cuireann sé seo thar ceann sannta láimhe)",
"classAllocation.autoAssignSuccess": "{{count}} dalta sannta do ranganna",
"classAllocation.autoAssignError": "Theip ar an uath-shannadh. Bain triail eile as.",
"classAllocation.exportCsv": "Easpórtáil Liostaí Ranga",
"classAllocation.teacher": "Múinteoir",
"classAllocation.noTeacher": "Gan múinteoir sannta",
"classAllocation.teacherAssignError": "Theip ar shannadh an mhúinteora. Bain triail eile as.",
"classAllocation.renameClass": "Cliceáil chun athainmniú",
"classAllocation.print": "Priontáil Liostaí Ranga",
"classAllocation.printedOn": "Priontáilte: {{date}}",
"classAllocation.clearAll": "Glan Gach Sannadh",
"classAllocation.clearConfirm": "Beidh sé seo ag baint gach sannadh ranga don chúrsa seo. An bhfuil tú cinnte?",
"classAllocation.clearAcknowledge": "Tuigim go mbeidh sé seo ag baint gach sannadh ranga don chúrsa seo go buan",
"classAllocation.clearPassword": "Deimhnigh do phasfhocal",
"classAllocation.clearPasswordPlaceholder": "Cuir isteach do phasfhocal",
"classAllocation.clearPasswordError": "Pasfhocal mícheart",
"classAllocation.clearedAll": "Gach sannadh glanaithe",
"classAllocation.clearedAllCount": "Baineadh {{count}} dalta(í) as a ranganna.",
"classAllocation.clearError": "Chuaigh rud éigin mícheart agus na sannta á nglanadh. Bain triail eile as.",
"classAllocation.friendGroupMoved": "Grúpa cairde sannta ({{count}} dalta)",
"classAllocation.friendGroupMovedDesc": "Bogadh gach ball den ghrúpa cairde le chéile.",
"classAllocation.error.capacityExceeded": "Tá an rang lán",
"classAllocation.error.capacityExceededDesc": "Níl go leor spásanna sa rang seo don dalta nó don ghrúpa seo.",
"classAllocation.error.cinnireOnly": "Srian rang na gCinnirí",
"classAllocation.error.cinnireOnlyDesc": "Ní féidir ach daltaí Cinnirí a chur i rang na gCinnirí.",
"classAllocation.error.cinnireMustGoToClass": "Ní mór do Chinnirí dul go rang na gCinnirí",
"classAllocation.error.cinnireMustGoToClassDesc": "Is Cinnire an dalta seo agus ní féidir é/í a shannadh ach don rang Cinnirí ainmnithe.",

"footer.builtBy": "Déanta ag",

"impersonation.banner": "Ag féachaint mar {{name}}",
"impersonation.readOnly": "léamh amháin",
"impersonation.stop": "Stad Ionadaíocht",
"impersonation.start": "Ionadaigh Úsáideoir",
"impersonation.errorTitle": "Theip ar an Ionadaíocht",

"teacherDashboard.myClasses": "Mo Ranganna",
"teacherDashboard.myClassesSubtitle": "Daltaí atá sannta do do ranganna do chúrsaí atá le teacht",
"teacherDashboard.noClassesForCourse": "Níl aon ranganna sannta duit don chúrsa seo",
"teacherDashboard.noStudentsInClass": "Níl aon daltaí sannta don rang seo",
"dashboard.classGroups": "Grúpaí Ranga",
"dashboard.viewAllocationBoard": "Féach ar an gClár Leithdháilte",

"houseOwnerDashboard.title": "Mo Thithe",
"houseOwnerDashboard.subtitle": "Do thithe do chúrsaí atá le teacht",
"houseOwnerDashboard.totalHouses": "Mo Thithe",
"houseOwnerDashboard.assigned": "Sannta",
"houseOwnerDashboard.unplaced": "Gan Lóistín",
"houseOwnerDashboard.noHouses": "Níl aon teach sannta duit fós",
"houseOwnerDashboard.noHousesDescription": "Déan teagmháil le riarthóir le go nascfar tú le do thithe.",
"houseOwnerDashboard.places": "áit",
"houseOwnerDashboard.allCourses": "Gach Cúrsa",
"houseOwnerDashboard.studentDetailsNotAvailable": "Beidh sonraí na ndaltaí ar fáil 2 lá roimh thús an chúrsa.",
"houseOwnerDashboard.noStudents": "Níl daltaí sannta fós",
"houseOwnerDashboard.name": "Ainm",
"houseOwnerDashboard.year": "Bliain",
"houseOwnerDashboard.county": "Contae",
"houseOwnerDashboard.parentPhone": "Fón",
"houseOwnerDashboard.parentEmail": "Ríomhphost",

// GDPR Cookie Consent
"gdpr.banner.title": "Úsáidimid fianáin",
"gdpr.banner.description": "Úsáidimid fianáin riachtanacha chun tú a logáil isteach agus fianáin roghanna chun do shocruithe a chuimhneamh.",
"gdpr.banner.privacyLink": "Polasaí Príobháideachais",
"gdpr.banner.acceptAll": "Glac le Gach",
"gdpr.banner.reject": "Diúltaigh Roghanna",
"gdpr.banner.settings": "Socruithe",
"gdpr.settings.title": "Socruithe Fianán",
"gdpr.settings.essential.title": "Fianáin Riachtanacha",
"gdpr.settings.essential.description": "Riachtanach le haghaidh logála isteach agus slándáil. Ní féidir iad a dhíchumasú.",
"gdpr.settings.functional.title": "Fianáin Roghanna",
"gdpr.settings.functional.description": "Cuimhníonn siad ar do rogha teanga agus ar shocruithe foirme. Oibríonn an suíomh gan iad seo.",
"gdpr.settings.acceptAll": "Glac le Gach",
"gdpr.settings.rejectAll": "Diúltaigh Roghanna",
"gdpr.settings.save": "Sábháil Roghanna",
"gdpr.footer.cookieSettings": "Socruithe Fianán",
"gdpr.footer.privacyPolicy": "Polasaí Príobháideachais",
"gdpr.privacy.lastUpdated": "Nuashonraithe"
};

export default gaTranslations;
